var An = Object.defineProperty, In = Object.defineProperties;
var Ln = Object.getOwnPropertyDescriptors;
var Nr = Object.getOwnPropertySymbols;
var Hn = Object.prototype.hasOwnProperty, Nn = Object.prototype.propertyIsEnumerable;
var Br = (e) => {
  throw TypeError(e);
};
var Rr = (e, r, t) => r in e ? An(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, ce = (e, r) => {
  for (var t in r || (r = {}))
    Hn.call(r, t) && Rr(e, t, r[t]);
  if (Nr)
    for (var t of Nr(r))
      Nn.call(r, t) && Rr(e, t, r[t]);
  return e;
}, he = (e, r) => In(e, Ln(r));
var le = (e, r, t) => r.has(e) || Br("Cannot " + t);
var L = (e, r, t) => (le(e, r, "read from private field"), t ? t.call(e) : r.get(e)), D = (e, r, t) => r.has(e) ? Br("Cannot add the same private member more than once") : r instanceof WeakSet ? r.add(e) : r.set(e, t), j = (e, r, t, n) => (le(e, r, "write to private field"), n ? n.call(e, t) : r.set(e, t), t), Q = (e, r, t) => (le(e, r, "access private method"), t);
var gr = function(e, r) {
  return gr = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, n) {
    t.__proto__ = n;
  } || function(t, n) {
    for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
  }, gr(e, r);
};
function R(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
  gr(e, r);
  function t() {
    this.constructor = e;
  }
  e.prototype = r === null ? Object.create(r) : (t.prototype = r.prototype, new t());
}
var f = function() {
  return f = Object.assign || function(r) {
    for (var t, n = 1, a = arguments.length; n < a; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (r[i] = t[i]);
    }
    return r;
  }, f.apply(this, arguments);
};
function Rn(e, r) {
  var t = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      r.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (t[n[a]] = e[n[a]]);
  return t;
}
function x(e, r, t) {
  if (t || arguments.length === 2) for (var n = 0, a = r.length, i; n < a; n++)
    (i || !(n in r)) && (i || (i = Array.prototype.slice.call(r, 0, n)), i[n] = r[n]);
  return e.concat(i || Array.prototype.slice.call(r));
}
function C(e, r) {
  var t = r && r.cache ? r.cache : Fn, n = r && r.serializer ? r.serializer : Dn, a = r && r.strategy ? r.strategy : On;
  return a(e, {
    cache: t,
    serializer: n
  });
}
function Bn(e) {
  return e == null || typeof e == "number" || typeof e == "boolean";
}
function Pn(e, r, t, n) {
  var a = Bn(n) ? n : t(n), i = r.get(a);
  return typeof i == "undefined" && (i = e.call(this, n), r.set(a, i)), i;
}
function Jt(e, r, t) {
  var n = Array.prototype.slice.call(arguments, 3), a = t(n), i = r.get(a);
  return typeof i == "undefined" && (i = e.apply(this, n), r.set(a, i)), i;
}
function Yt(e, r, t, n, a) {
  return t.bind(r, e, n, a);
}
function On(e, r) {
  var t = e.length === 1 ? Pn : Jt;
  return Yt(e, this, t, r.cache.create(), r.serializer);
}
function Gn(e, r) {
  return Yt(e, this, Jt, r.cache.create(), r.serializer);
}
var Dn = function() {
  return JSON.stringify(arguments);
};
function xr() {
  this.cache = /* @__PURE__ */ Object.create(null);
}
xr.prototype.get = function(e) {
  return this.cache[e];
};
xr.prototype.set = function(e, r) {
  this.cache[e] = r;
};
var Fn = {
  create: function() {
    return new xr();
  }
}, A = {
  variadic: Gn
}, p;
(function(e) {
  e[e.EXPECT_ARGUMENT_CLOSING_BRACE = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE", e[e.EMPTY_ARGUMENT = 2] = "EMPTY_ARGUMENT", e[e.MALFORMED_ARGUMENT = 3] = "MALFORMED_ARGUMENT", e[e.EXPECT_ARGUMENT_TYPE = 4] = "EXPECT_ARGUMENT_TYPE", e[e.INVALID_ARGUMENT_TYPE = 5] = "INVALID_ARGUMENT_TYPE", e[e.EXPECT_ARGUMENT_STYLE = 6] = "EXPECT_ARGUMENT_STYLE", e[e.INVALID_NUMBER_SKELETON = 7] = "INVALID_NUMBER_SKELETON", e[e.INVALID_DATE_TIME_SKELETON = 8] = "INVALID_DATE_TIME_SKELETON", e[e.EXPECT_NUMBER_SKELETON = 9] = "EXPECT_NUMBER_SKELETON", e[e.EXPECT_DATE_TIME_SKELETON = 10] = "EXPECT_DATE_TIME_SKELETON", e[e.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE", e[e.EXPECT_SELECT_ARGUMENT_OPTIONS = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS", e[e.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT", e[e.INVALID_PLURAL_ARGUMENT_SELECTOR = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_PLURAL_ARGUMENT_SELECTOR = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_SELECT_ARGUMENT_SELECTOR = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR", e[e.MISSING_OTHER_CLAUSE = 22] = "MISSING_OTHER_CLAUSE", e[e.INVALID_TAG = 23] = "INVALID_TAG", e[e.INVALID_TAG_NAME = 25] = "INVALID_TAG_NAME", e[e.UNMATCHED_CLOSING_TAG = 26] = "UNMATCHED_CLOSING_TAG", e[e.UNCLOSED_TAG = 27] = "UNCLOSED_TAG";
})(p || (p = {}));
var w;
(function(e) {
  e[e.literal = 0] = "literal", e[e.argument = 1] = "argument", e[e.number = 2] = "number", e[e.date = 3] = "date", e[e.time = 4] = "time", e[e.select = 5] = "select", e[e.plural = 6] = "plural", e[e.pound = 7] = "pound", e[e.tag = 8] = "tag";
})(w || (w = {}));
var X;
(function(e) {
  e[e.number = 0] = "number", e[e.dateTime = 1] = "dateTime";
})(X || (X = {}));
function Pr(e) {
  return e.type === w.literal;
}
function Un(e) {
  return e.type === w.argument;
}
function $t(e) {
  return e.type === w.number;
}
function Qt(e) {
  return e.type === w.date;
}
function en(e) {
  return e.type === w.time;
}
function rn(e) {
  return e.type === w.select;
}
function tn(e) {
  return e.type === w.plural;
}
function qn(e) {
  return e.type === w.pound;
}
function nn(e) {
  return e.type === w.tag;
}
function an(e) {
  return !!(e && typeof e == "object" && e.type === X.number);
}
function pr(e) {
  return !!(e && typeof e == "object" && e.type === X.dateTime);
}
var sn = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/, jn = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function Vn(e) {
  var r = {};
  return e.replace(jn, function(t) {
    var n = t.length;
    switch (t[0]) {
      // Era
      case "G":
        r.era = n === 4 ? "long" : n === 5 ? "narrow" : "short";
        break;
      // Year
      case "y":
        r.year = n === 2 ? "2-digit" : "numeric";
        break;
      case "Y":
      case "u":
      case "U":
      case "r":
        throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
      // Quarter
      case "q":
      case "Q":
        throw new RangeError("`q/Q` (quarter) patterns are not supported");
      // Month
      case "M":
      case "L":
        r.month = ["numeric", "2-digit", "short", "long", "narrow"][n - 1];
        break;
      // Week
      case "w":
      case "W":
        throw new RangeError("`w/W` (week) patterns are not supported");
      case "d":
        r.day = ["numeric", "2-digit"][n - 1];
        break;
      case "D":
      case "F":
      case "g":
        throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
      // Weekday
      case "E":
        r.weekday = n === 4 ? "long" : n === 5 ? "narrow" : "short";
        break;
      case "e":
        if (n < 4)
          throw new RangeError("`e..eee` (weekday) patterns are not supported");
        r.weekday = ["short", "long", "narrow", "short"][n - 4];
        break;
      case "c":
        if (n < 4)
          throw new RangeError("`c..ccc` (weekday) patterns are not supported");
        r.weekday = ["short", "long", "narrow", "short"][n - 4];
        break;
      // Period
      case "a":
        r.hour12 = !0;
        break;
      case "b":
      // am, pm, noon, midnight
      case "B":
        throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
      // Hour
      case "h":
        r.hourCycle = "h12", r.hour = ["numeric", "2-digit"][n - 1];
        break;
      case "H":
        r.hourCycle = "h23", r.hour = ["numeric", "2-digit"][n - 1];
        break;
      case "K":
        r.hourCycle = "h11", r.hour = ["numeric", "2-digit"][n - 1];
        break;
      case "k":
        r.hourCycle = "h24", r.hour = ["numeric", "2-digit"][n - 1];
        break;
      case "j":
      case "J":
      case "C":
        throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
      // Minute
      case "m":
        r.minute = ["numeric", "2-digit"][n - 1];
        break;
      // Second
      case "s":
        r.second = ["numeric", "2-digit"][n - 1];
        break;
      case "S":
      case "A":
        throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
      // Zone
      case "z":
        r.timeZoneName = n < 4 ? "short" : "long";
        break;
      case "Z":
      // 1..3, 4, 5: The ISO8601 varios formats
      case "O":
      // 1, 4: milliseconds in day short, long
      case "v":
      // 1, 4: generic non-location format
      case "V":
      // 1, 2, 3, 4: time zone ID or city
      case "X":
      // 1, 2, 3, 4: The ISO8601 varios formats
      case "x":
        throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
    }
    return "";
  }), r;
}
var kn = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;
function Kn(e) {
  if (e.length === 0)
    throw new Error("Number skeleton cannot be empty");
  for (var r = e.split(kn).filter(function(h) {
    return h.length > 0;
  }), t = [], n = 0, a = r; n < a.length; n++) {
    var i = a[n], s = i.split("/");
    if (s.length === 0)
      throw new Error("Invalid number skeleton");
    for (var o = s[0], u = s.slice(1), d = 0, c = u; d < c.length; d++) {
      var l = c[d];
      if (l.length === 0)
        throw new Error("Invalid number skeleton");
    }
    t.push({ stem: o, options: u });
  }
  return t;
}
function zn(e) {
  return e.replace(/^(.*?)-/, "");
}
var Or = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g, on = /^(@+)?(\+|#+)?[rs]?$/g, Zn = /(\*)(0+)|(#+)(0+)|(0+)/g, un = /^(0+)$/;
function Gr(e) {
  var r = {};
  return e[e.length - 1] === "r" ? r.roundingPriority = "morePrecision" : e[e.length - 1] === "s" && (r.roundingPriority = "lessPrecision"), e.replace(on, function(t, n, a) {
    return typeof a != "string" ? (r.minimumSignificantDigits = n.length, r.maximumSignificantDigits = n.length) : a === "+" ? r.minimumSignificantDigits = n.length : n[0] === "#" ? r.maximumSignificantDigits = n.length : (r.minimumSignificantDigits = n.length, r.maximumSignificantDigits = n.length + (typeof a == "string" ? a.length : 0)), "";
  }), r;
}
function dn(e) {
  switch (e) {
    case "sign-auto":
      return {
        signDisplay: "auto"
      };
    case "sign-accounting":
    case "()":
      return {
        currencySign: "accounting"
      };
    case "sign-always":
    case "+!":
      return {
        signDisplay: "always"
      };
    case "sign-accounting-always":
    case "()!":
      return {
        signDisplay: "always",
        currencySign: "accounting"
      };
    case "sign-except-zero":
    case "+?":
      return {
        signDisplay: "exceptZero"
      };
    case "sign-accounting-except-zero":
    case "()?":
      return {
        signDisplay: "exceptZero",
        currencySign: "accounting"
      };
    case "sign-never":
    case "+_":
      return {
        signDisplay: "never"
      };
  }
}
function Wn(e) {
  var r;
  if (e[0] === "E" && e[1] === "E" ? (r = {
    notation: "engineering"
  }, e = e.slice(2)) : e[0] === "E" && (r = {
    notation: "scientific"
  }, e = e.slice(1)), r) {
    var t = e.slice(0, 2);
    if (t === "+!" ? (r.signDisplay = "always", e = e.slice(2)) : t === "+?" && (r.signDisplay = "exceptZero", e = e.slice(2)), !un.test(e))
      throw new Error("Malformed concise eng/scientific notation");
    r.minimumIntegerDigits = e.length;
  }
  return r;
}
function Dr(e) {
  var r = {}, t = dn(e);
  return t || r;
}
function Xn(e) {
  for (var r = {}, t = 0, n = e; t < n.length; t++) {
    var a = n[t];
    switch (a.stem) {
      case "percent":
      case "%":
        r.style = "percent";
        continue;
      case "%x100":
        r.style = "percent", r.scale = 100;
        continue;
      case "currency":
        r.style = "currency", r.currency = a.options[0];
        continue;
      case "group-off":
      case ",_":
        r.useGrouping = !1;
        continue;
      case "precision-integer":
      case ".":
        r.maximumFractionDigits = 0;
        continue;
      case "measure-unit":
      case "unit":
        r.style = "unit", r.unit = zn(a.options[0]);
        continue;
      case "compact-short":
      case "K":
        r.notation = "compact", r.compactDisplay = "short";
        continue;
      case "compact-long":
      case "KK":
        r.notation = "compact", r.compactDisplay = "long";
        continue;
      case "scientific":
        r = f(f(f({}, r), { notation: "scientific" }), a.options.reduce(function(u, d) {
          return f(f({}, u), Dr(d));
        }, {}));
        continue;
      case "engineering":
        r = f(f(f({}, r), { notation: "engineering" }), a.options.reduce(function(u, d) {
          return f(f({}, u), Dr(d));
        }, {}));
        continue;
      case "notation-simple":
        r.notation = "standard";
        continue;
      // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
      case "unit-width-narrow":
        r.currencyDisplay = "narrowSymbol", r.unitDisplay = "narrow";
        continue;
      case "unit-width-short":
        r.currencyDisplay = "code", r.unitDisplay = "short";
        continue;
      case "unit-width-full-name":
        r.currencyDisplay = "name", r.unitDisplay = "long";
        continue;
      case "unit-width-iso-code":
        r.currencyDisplay = "symbol";
        continue;
      case "scale":
        r.scale = parseFloat(a.options[0]);
        continue;
      case "rounding-mode-floor":
        r.roundingMode = "floor";
        continue;
      case "rounding-mode-ceiling":
        r.roundingMode = "ceil";
        continue;
      case "rounding-mode-down":
        r.roundingMode = "trunc";
        continue;
      case "rounding-mode-up":
        r.roundingMode = "expand";
        continue;
      case "rounding-mode-half-even":
        r.roundingMode = "halfEven";
        continue;
      case "rounding-mode-half-down":
        r.roundingMode = "halfTrunc";
        continue;
      case "rounding-mode-half-up":
        r.roundingMode = "halfExpand";
        continue;
      // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
      case "integer-width":
        if (a.options.length > 1)
          throw new RangeError("integer-width stems only accept a single optional option");
        a.options[0].replace(Zn, function(u, d, c, l, h, y) {
          if (d)
            r.minimumIntegerDigits = c.length;
          else {
            if (l && h)
              throw new Error("We currently do not support maximum integer digits");
            if (y)
              throw new Error("We currently do not support exact integer digits");
          }
          return "";
        });
        continue;
    }
    if (un.test(a.stem)) {
      r.minimumIntegerDigits = a.stem.length;
      continue;
    }
    if (Or.test(a.stem)) {
      if (a.options.length > 1)
        throw new RangeError("Fraction-precision stems only accept a single optional option");
      a.stem.replace(Or, function(u, d, c, l, h, y) {
        return c === "*" ? r.minimumFractionDigits = d.length : l && l[0] === "#" ? r.maximumFractionDigits = l.length : h && y ? (r.minimumFractionDigits = h.length, r.maximumFractionDigits = h.length + y.length) : (r.minimumFractionDigits = d.length, r.maximumFractionDigits = d.length), "";
      });
      var i = a.options[0];
      i === "w" ? r = f(f({}, r), { trailingZeroDisplay: "stripIfInteger" }) : i && (r = f(f({}, r), Gr(i)));
      continue;
    }
    if (on.test(a.stem)) {
      r = f(f({}, r), Gr(a.stem));
      continue;
    }
    var s = dn(a.stem);
    s && (r = f(f({}, r), s));
    var o = Wn(a.stem);
    o && (r = f(f({}, r), o));
  }
  return r;
}
var ee = {
  "001": [
    "H",
    "h"
  ],
  419: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  AC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AD: [
    "H",
    "hB"
  ],
  AE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  AF: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  AG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AL: [
    "h",
    "H",
    "hB"
  ],
  AM: [
    "H",
    "hB"
  ],
  AO: [
    "H",
    "hB"
  ],
  AR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  AS: [
    "h",
    "H"
  ],
  AT: [
    "H",
    "hB"
  ],
  AU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AW: [
    "H",
    "hB"
  ],
  AX: [
    "H"
  ],
  AZ: [
    "H",
    "hB",
    "h"
  ],
  BA: [
    "H",
    "hB",
    "h"
  ],
  BB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BD: [
    "h",
    "hB",
    "H"
  ],
  BE: [
    "H",
    "hB"
  ],
  BF: [
    "H",
    "hB"
  ],
  BG: [
    "H",
    "hB",
    "h"
  ],
  BH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  BI: [
    "H",
    "h"
  ],
  BJ: [
    "H",
    "hB"
  ],
  BL: [
    "H",
    "hB"
  ],
  BM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BN: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  BO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  BQ: [
    "H"
  ],
  BR: [
    "H",
    "hB"
  ],
  BS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BT: [
    "h",
    "H"
  ],
  BW: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  BY: [
    "H",
    "h"
  ],
  BZ: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CA: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  CC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CD: [
    "hB",
    "H"
  ],
  CF: [
    "H",
    "h",
    "hB"
  ],
  CG: [
    "H",
    "hB"
  ],
  CH: [
    "H",
    "hB",
    "h"
  ],
  CI: [
    "H",
    "hB"
  ],
  CK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CL: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  CM: [
    "H",
    "h",
    "hB"
  ],
  CN: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  CO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  CP: [
    "H"
  ],
  CR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  CU: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  CV: [
    "H",
    "hB"
  ],
  CW: [
    "H",
    "hB"
  ],
  CX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CY: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  CZ: [
    "H"
  ],
  DE: [
    "H",
    "hB"
  ],
  DG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  DJ: [
    "h",
    "H"
  ],
  DK: [
    "H"
  ],
  DM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  DO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  DZ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  EC: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  EE: [
    "H",
    "hB"
  ],
  EG: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  ER: [
    "h",
    "H"
  ],
  ES: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  ET: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  FI: [
    "H"
  ],
  FJ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  FM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FO: [
    "H",
    "h"
  ],
  FR: [
    "H",
    "hB"
  ],
  GA: [
    "H",
    "hB"
  ],
  GB: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GD: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GE: [
    "H",
    "hB",
    "h"
  ],
  GF: [
    "H",
    "hB"
  ],
  GG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GH: [
    "h",
    "H"
  ],
  GI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GL: [
    "H",
    "h"
  ],
  GM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GN: [
    "H",
    "hB"
  ],
  GP: [
    "H",
    "hB"
  ],
  GQ: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  GR: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  GT: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  GU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GW: [
    "H",
    "hB"
  ],
  GY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  HK: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  HN: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  HR: [
    "H",
    "hB"
  ],
  HU: [
    "H",
    "h"
  ],
  IC: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  ID: [
    "H"
  ],
  IE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IL: [
    "H",
    "hB"
  ],
  IM: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IN: [
    "h",
    "H"
  ],
  IO: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IQ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  IR: [
    "hB",
    "H"
  ],
  IS: [
    "H"
  ],
  IT: [
    "H",
    "hB"
  ],
  JE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  JM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  JO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  JP: [
    "H",
    "K",
    "h"
  ],
  KE: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  KG: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KH: [
    "hB",
    "h",
    "H",
    "hb"
  ],
  KI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KM: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KN: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KP: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KW: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  KY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KZ: [
    "H",
    "hB"
  ],
  LA: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  LB: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  LC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LI: [
    "H",
    "hB",
    "h"
  ],
  LK: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  LR: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LS: [
    "h",
    "H"
  ],
  LT: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  LU: [
    "H",
    "h",
    "hB"
  ],
  LV: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  LY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  MC: [
    "H",
    "hB"
  ],
  MD: [
    "H",
    "hB"
  ],
  ME: [
    "H",
    "hB",
    "h"
  ],
  MF: [
    "H",
    "hB"
  ],
  MG: [
    "H",
    "h"
  ],
  MH: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ML: [
    "H"
  ],
  MM: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  MN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MP: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MQ: [
    "H",
    "hB"
  ],
  MR: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MS: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MT: [
    "H",
    "h"
  ],
  MU: [
    "H",
    "h"
  ],
  MV: [
    "H",
    "h"
  ],
  MW: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MX: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  MY: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  MZ: [
    "H",
    "hB"
  ],
  NA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  NC: [
    "H",
    "hB"
  ],
  NE: [
    "H"
  ],
  NF: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NI: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  NL: [
    "H",
    "hB"
  ],
  NO: [
    "H",
    "h"
  ],
  NP: [
    "H",
    "h",
    "hB"
  ],
  NR: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NU: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  OM: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PE: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PF: [
    "H",
    "h",
    "hB"
  ],
  PG: [
    "h",
    "H"
  ],
  PH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PK: [
    "h",
    "hB",
    "H"
  ],
  PL: [
    "H",
    "h"
  ],
  PM: [
    "H",
    "hB"
  ],
  PN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  PR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PS: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PT: [
    "H",
    "hB"
  ],
  PW: [
    "h",
    "H"
  ],
  PY: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  QA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  RE: [
    "H",
    "hB"
  ],
  RO: [
    "H",
    "hB"
  ],
  RS: [
    "H",
    "hB",
    "h"
  ],
  RU: [
    "H"
  ],
  RW: [
    "H",
    "h"
  ],
  SA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SC: [
    "H",
    "h",
    "hB"
  ],
  SD: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SE: [
    "H"
  ],
  SG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SH: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SI: [
    "H",
    "hB"
  ],
  SJ: [
    "H"
  ],
  SK: [
    "H"
  ],
  SL: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SM: [
    "H",
    "h",
    "hB"
  ],
  SN: [
    "H",
    "h",
    "hB"
  ],
  SO: [
    "h",
    "H"
  ],
  SR: [
    "H",
    "hB"
  ],
  SS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ST: [
    "H",
    "hB"
  ],
  SV: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  SX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  TC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TD: [
    "h",
    "H",
    "hB"
  ],
  TF: [
    "H",
    "h",
    "hB"
  ],
  TG: [
    "H",
    "hB"
  ],
  TH: [
    "H",
    "h"
  ],
  TJ: [
    "H",
    "h"
  ],
  TL: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  TM: [
    "H",
    "h"
  ],
  TN: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  TO: [
    "h",
    "H"
  ],
  TR: [
    "H",
    "hB"
  ],
  TT: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TW: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  TZ: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UA: [
    "H",
    "hB",
    "h"
  ],
  UG: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  US: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  UY: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  UZ: [
    "H",
    "hB",
    "h"
  ],
  VA: [
    "H",
    "h",
    "hB"
  ],
  VC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VE: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  VG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VN: [
    "H",
    "h"
  ],
  VU: [
    "h",
    "H"
  ],
  WF: [
    "H",
    "hB"
  ],
  WS: [
    "h",
    "H"
  ],
  XK: [
    "H",
    "hB",
    "h"
  ],
  YE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  YT: [
    "H",
    "hB"
  ],
  ZA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ZM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ZW: [
    "H",
    "h"
  ],
  "af-ZA": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "ar-001": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "ca-ES": [
    "H",
    "h",
    "hB"
  ],
  "en-001": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "en-HK": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "en-IL": [
    "H",
    "h",
    "hb",
    "hB"
  ],
  "en-MY": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "es-BR": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-ES": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-GQ": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "fr-CA": [
    "H",
    "h",
    "hB"
  ],
  "gl-ES": [
    "H",
    "h",
    "hB"
  ],
  "gu-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "hi-IN": [
    "hB",
    "h",
    "H"
  ],
  "it-CH": [
    "H",
    "h",
    "hB"
  ],
  "it-IT": [
    "H",
    "h",
    "hB"
  ],
  "kn-IN": [
    "hB",
    "h",
    "H"
  ],
  "ml-IN": [
    "hB",
    "h",
    "H"
  ],
  "mr-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "pa-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "ta-IN": [
    "hB",
    "h",
    "hb",
    "H"
  ],
  "te-IN": [
    "hB",
    "h",
    "H"
  ],
  "zu-ZA": [
    "H",
    "hB",
    "hb",
    "h"
  ]
};
function Jn(e, r) {
  for (var t = "", n = 0; n < e.length; n++) {
    var a = e.charAt(n);
    if (a === "j") {
      for (var i = 0; n + 1 < e.length && e.charAt(n + 1) === a; )
        i++, n++;
      var s = 1 + (i & 1), o = i < 2 ? 1 : 3 + (i >> 1), u = "a", d = Yn(r);
      for ((d == "H" || d == "k") && (o = 0); o-- > 0; )
        t += u;
      for (; s-- > 0; )
        t = d + t;
    } else a === "J" ? t += "H" : t += a;
  }
  return t;
}
function Yn(e) {
  var r = e.hourCycle;
  if (r === void 0 && // @ts-ignore hourCycle(s) is not identified yet
  e.hourCycles && // @ts-ignore
  e.hourCycles.length && (r = e.hourCycles[0]), r)
    switch (r) {
      case "h24":
        return "k";
      case "h23":
        return "H";
      case "h12":
        return "h";
      case "h11":
        return "K";
      default:
        throw new Error("Invalid hourCycle");
    }
  var t = e.language, n;
  t !== "root" && (n = e.maximize().region);
  var a = ee[n || ""] || ee[t || ""] || ee["".concat(t, "-001")] || ee["001"];
  return a[0];
}
var _e, $n = new RegExp("^".concat(sn.source, "*")), Qn = new RegExp("".concat(sn.source, "*$"));
function b(e, r) {
  return { start: e, end: r };
}
var ea = !!String.prototype.startsWith && "_a".startsWith("a", 1), ra = !!String.fromCodePoint, ta = !!Object.fromEntries, na = !!String.prototype.codePointAt, aa = !!String.prototype.trimStart, ia = !!String.prototype.trimEnd, sa = !!Number.isSafeInteger, oa = sa ? Number.isSafeInteger : function(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e && Math.abs(e) <= 9007199254740991;
}, br = !0;
try {
  var ua = hn("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  br = ((_e = ua.exec("a")) === null || _e === void 0 ? void 0 : _e[0]) === "a";
} catch (e) {
  br = !1;
}
var Fr = ea ? (
  // Native
  function(r, t, n) {
    return r.startsWith(t, n);
  }
) : (
  // For IE11
  function(r, t, n) {
    return r.slice(n, n + t.length) === t;
  }
), Er = ra ? String.fromCodePoint : (
  // IE11
  function() {
    for (var r = [], t = 0; t < arguments.length; t++)
      r[t] = arguments[t];
    for (var n = "", a = r.length, i = 0, s; a > i; ) {
      if (s = r[i++], s > 1114111)
        throw RangeError(s + " is not a valid code point");
      n += s < 65536 ? String.fromCharCode(s) : String.fromCharCode(((s -= 65536) >> 10) + 55296, s % 1024 + 56320);
    }
    return n;
  }
), Ur = (
  // native
  ta ? Object.fromEntries : (
    // Ponyfill
    function(r) {
      for (var t = {}, n = 0, a = r; n < a.length; n++) {
        var i = a[n], s = i[0], o = i[1];
        t[s] = o;
      }
      return t;
    }
  )
), cn = na ? (
  // Native
  function(r, t) {
    return r.codePointAt(t);
  }
) : (
  // IE 11
  function(r, t) {
    var n = r.length;
    if (!(t < 0 || t >= n)) {
      var a = r.charCodeAt(t), i;
      return a < 55296 || a > 56319 || t + 1 === n || (i = r.charCodeAt(t + 1)) < 56320 || i > 57343 ? a : (a - 55296 << 10) + (i - 56320) + 65536;
    }
  }
), da = aa ? (
  // Native
  function(r) {
    return r.trimStart();
  }
) : (
  // Ponyfill
  function(r) {
    return r.replace($n, "");
  }
), ca = ia ? (
  // Native
  function(r) {
    return r.trimEnd();
  }
) : (
  // Ponyfill
  function(r) {
    return r.replace(Qn, "");
  }
);
function hn(e, r) {
  return new RegExp(e, r);
}
var wr;
if (br) {
  var qr = hn("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  wr = function(r, t) {
    var n;
    qr.lastIndex = t;
    var a = qr.exec(r);
    return (n = a[1]) !== null && n !== void 0 ? n : "";
  };
} else
  wr = function(r, t) {
    for (var n = []; ; ) {
      var a = cn(r, t);
      if (a === void 0 || ln(a) || fa(a))
        break;
      n.push(a), t += a >= 65536 ? 2 : 1;
    }
    return Er.apply(void 0, n);
  };
var ha = (
  /** @class */
  function() {
    function e(r, t) {
      t === void 0 && (t = {}), this.message = r, this.position = { offset: 0, line: 1, column: 1 }, this.ignoreTag = !!t.ignoreTag, this.locale = t.locale, this.requiresOtherClause = !!t.requiresOtherClause, this.shouldParseSkeletons = !!t.shouldParseSkeletons;
    }
    return e.prototype.parse = function() {
      if (this.offset() !== 0)
        throw Error("parser can only be used once");
      return this.parseMessage(0, "", !1);
    }, e.prototype.parseMessage = function(r, t, n) {
      for (var a = []; !this.isEOF(); ) {
        var i = this.char();
        if (i === 123) {
          var s = this.parseArgument(r, n);
          if (s.err)
            return s;
          a.push(s.val);
        } else {
          if (i === 125 && r > 0)
            break;
          if (i === 35 && (t === "plural" || t === "selectordinal")) {
            var o = this.clonePosition();
            this.bump(), a.push({
              type: w.pound,
              location: b(o, this.clonePosition())
            });
          } else if (i === 60 && !this.ignoreTag && this.peek() === 47) {
            if (n)
              break;
            return this.error(p.UNMATCHED_CLOSING_TAG, b(this.clonePosition(), this.clonePosition()));
          } else if (i === 60 && !this.ignoreTag && Tr(this.peek() || 0)) {
            var s = this.parseTag(r, t);
            if (s.err)
              return s;
            a.push(s.val);
          } else {
            var s = this.parseLiteral(r, t);
            if (s.err)
              return s;
            a.push(s.val);
          }
        }
      }
      return { val: a, err: null };
    }, e.prototype.parseTag = function(r, t) {
      var n = this.clonePosition();
      this.bump();
      var a = this.parseTagName();
      if (this.bumpSpace(), this.bumpIf("/>"))
        return {
          val: {
            type: w.literal,
            value: "<".concat(a, "/>"),
            location: b(n, this.clonePosition())
          },
          err: null
        };
      if (this.bumpIf(">")) {
        var i = this.parseMessage(r + 1, t, !0);
        if (i.err)
          return i;
        var s = i.val, o = this.clonePosition();
        if (this.bumpIf("</")) {
          if (this.isEOF() || !Tr(this.char()))
            return this.error(p.INVALID_TAG, b(o, this.clonePosition()));
          var u = this.clonePosition(), d = this.parseTagName();
          return a !== d ? this.error(p.UNMATCHED_CLOSING_TAG, b(u, this.clonePosition())) : (this.bumpSpace(), this.bumpIf(">") ? {
            val: {
              type: w.tag,
              value: a,
              children: s,
              location: b(n, this.clonePosition())
            },
            err: null
          } : this.error(p.INVALID_TAG, b(o, this.clonePosition())));
        } else
          return this.error(p.UNCLOSED_TAG, b(n, this.clonePosition()));
      } else
        return this.error(p.INVALID_TAG, b(n, this.clonePosition()));
    }, e.prototype.parseTagName = function() {
      var r = this.offset();
      for (this.bump(); !this.isEOF() && _a(this.char()); )
        this.bump();
      return this.message.slice(r, this.offset());
    }, e.prototype.parseLiteral = function(r, t) {
      for (var n = this.clonePosition(), a = ""; ; ) {
        var i = this.tryParseQuote(t);
        if (i) {
          a += i;
          continue;
        }
        var s = this.tryParseUnquoted(r, t);
        if (s) {
          a += s;
          continue;
        }
        var o = this.tryParseLeftAngleBracket();
        if (o) {
          a += o;
          continue;
        }
        break;
      }
      var u = b(n, this.clonePosition());
      return {
        val: { type: w.literal, value: a, location: u },
        err: null
      };
    }, e.prototype.tryParseLeftAngleBracket = function() {
      return !this.isEOF() && this.char() === 60 && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
      !la(this.peek() || 0)) ? (this.bump(), "<") : null;
    }, e.prototype.tryParseQuote = function(r) {
      if (this.isEOF() || this.char() !== 39)
        return null;
      switch (this.peek()) {
        case 39:
          return this.bump(), this.bump(), "'";
        // '{', '<', '>', '}'
        case 123:
        case 60:
        case 62:
        case 125:
          break;
        case 35:
          if (r === "plural" || r === "selectordinal")
            break;
          return null;
        default:
          return null;
      }
      this.bump();
      var t = [this.char()];
      for (this.bump(); !this.isEOF(); ) {
        var n = this.char();
        if (n === 39)
          if (this.peek() === 39)
            t.push(39), this.bump();
          else {
            this.bump();
            break;
          }
        else
          t.push(n);
        this.bump();
      }
      return Er.apply(void 0, t);
    }, e.prototype.tryParseUnquoted = function(r, t) {
      if (this.isEOF())
        return null;
      var n = this.char();
      return n === 60 || n === 123 || n === 35 && (t === "plural" || t === "selectordinal") || n === 125 && r > 0 ? null : (this.bump(), Er(n));
    }, e.prototype.parseArgument = function(r, t) {
      var n = this.clonePosition();
      if (this.bump(), this.bumpSpace(), this.isEOF())
        return this.error(p.EXPECT_ARGUMENT_CLOSING_BRACE, b(n, this.clonePosition()));
      if (this.char() === 125)
        return this.bump(), this.error(p.EMPTY_ARGUMENT, b(n, this.clonePosition()));
      var a = this.parseIdentifierIfPossible().value;
      if (!a)
        return this.error(p.MALFORMED_ARGUMENT, b(n, this.clonePosition()));
      if (this.bumpSpace(), this.isEOF())
        return this.error(p.EXPECT_ARGUMENT_CLOSING_BRACE, b(n, this.clonePosition()));
      switch (this.char()) {
        // Simple argument: `{name}`
        case 125:
          return this.bump(), {
            val: {
              type: w.argument,
              // value does not include the opening and closing braces.
              value: a,
              location: b(n, this.clonePosition())
            },
            err: null
          };
        // Argument with options: `{name, format, ...}`
        case 44:
          return this.bump(), this.bumpSpace(), this.isEOF() ? this.error(p.EXPECT_ARGUMENT_CLOSING_BRACE, b(n, this.clonePosition())) : this.parseArgumentOptions(r, t, a, n);
        default:
          return this.error(p.MALFORMED_ARGUMENT, b(n, this.clonePosition()));
      }
    }, e.prototype.parseIdentifierIfPossible = function() {
      var r = this.clonePosition(), t = this.offset(), n = wr(this.message, t), a = t + n.length;
      this.bumpTo(a);
      var i = this.clonePosition(), s = b(r, i);
      return { value: n, location: s };
    }, e.prototype.parseArgumentOptions = function(r, t, n, a) {
      var i, s = this.clonePosition(), o = this.parseIdentifierIfPossible().value, u = this.clonePosition();
      switch (o) {
        case "":
          return this.error(p.EXPECT_ARGUMENT_TYPE, b(s, u));
        case "number":
        case "date":
        case "time": {
          this.bumpSpace();
          var d = null;
          if (this.bumpIf(",")) {
            this.bumpSpace();
            var c = this.clonePosition(), l = this.parseSimpleArgStyleIfPossible();
            if (l.err)
              return l;
            var h = ca(l.val);
            if (h.length === 0)
              return this.error(p.EXPECT_ARGUMENT_STYLE, b(this.clonePosition(), this.clonePosition()));
            var y = b(c, this.clonePosition());
            d = { style: h, styleLocation: y };
          }
          var m = this.tryParseArgumentClose(a);
          if (m.err)
            return m;
          var _ = b(a, this.clonePosition());
          if (d && Fr(d == null ? void 0 : d.style, "::", 0)) {
            var v = da(d.style.slice(2));
            if (o === "number") {
              var l = this.parseNumberSkeletonFromString(v, d.styleLocation);
              return l.err ? l : {
                val: { type: w.number, value: n, location: _, style: l.val },
                err: null
              };
            } else {
              if (v.length === 0)
                return this.error(p.EXPECT_DATE_TIME_SKELETON, _);
              var g = v;
              this.locale && (g = Jn(v, this.locale));
              var h = {
                type: X.dateTime,
                pattern: g,
                location: d.styleLocation,
                parsedOptions: this.shouldParseSkeletons ? Vn(g) : {}
              }, E = o === "date" ? w.date : w.time;
              return {
                val: { type: E, value: n, location: _, style: h },
                err: null
              };
            }
          }
          return {
            val: {
              type: o === "number" ? w.number : o === "date" ? w.date : w.time,
              value: n,
              location: _,
              style: (i = d == null ? void 0 : d.style) !== null && i !== void 0 ? i : null
            },
            err: null
          };
        }
        case "plural":
        case "selectordinal":
        case "select": {
          var T = this.clonePosition();
          if (this.bumpSpace(), !this.bumpIf(","))
            return this.error(p.EXPECT_SELECT_ARGUMENT_OPTIONS, b(T, f({}, T)));
          this.bumpSpace();
          var S = this.parseIdentifierIfPossible(), H = 0;
          if (o !== "select" && S.value === "offset") {
            if (!this.bumpIf(":"))
              return this.error(p.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, b(this.clonePosition(), this.clonePosition()));
            this.bumpSpace();
            var l = this.tryParseDecimalInteger(p.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, p.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
            if (l.err)
              return l;
            this.bumpSpace(), S = this.parseIdentifierIfPossible(), H = l.val;
          }
          var I = this.tryParsePluralOrSelectOptions(r, o, t, S);
          if (I.err)
            return I;
          var m = this.tryParseArgumentClose(a);
          if (m.err)
            return m;
          var G = b(a, this.clonePosition());
          return o === "select" ? {
            val: {
              type: w.select,
              value: n,
              options: Ur(I.val),
              location: G
            },
            err: null
          } : {
            val: {
              type: w.plural,
              value: n,
              options: Ur(I.val),
              offset: H,
              pluralType: o === "plural" ? "cardinal" : "ordinal",
              location: G
            },
            err: null
          };
        }
        default:
          return this.error(p.INVALID_ARGUMENT_TYPE, b(s, u));
      }
    }, e.prototype.tryParseArgumentClose = function(r) {
      return this.isEOF() || this.char() !== 125 ? this.error(p.EXPECT_ARGUMENT_CLOSING_BRACE, b(r, this.clonePosition())) : (this.bump(), { val: !0, err: null });
    }, e.prototype.parseSimpleArgStyleIfPossible = function() {
      for (var r = 0, t = this.clonePosition(); !this.isEOF(); ) {
        var n = this.char();
        switch (n) {
          case 39: {
            this.bump();
            var a = this.clonePosition();
            if (!this.bumpUntil("'"))
              return this.error(p.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, b(a, this.clonePosition()));
            this.bump();
            break;
          }
          case 123: {
            r += 1, this.bump();
            break;
          }
          case 125: {
            if (r > 0)
              r -= 1;
            else
              return {
                val: this.message.slice(t.offset, this.offset()),
                err: null
              };
            break;
          }
          default:
            this.bump();
            break;
        }
      }
      return {
        val: this.message.slice(t.offset, this.offset()),
        err: null
      };
    }, e.prototype.parseNumberSkeletonFromString = function(r, t) {
      var n = [];
      try {
        n = Kn(r);
      } catch (a) {
        return this.error(p.INVALID_NUMBER_SKELETON, t);
      }
      return {
        val: {
          type: X.number,
          tokens: n,
          location: t,
          parsedOptions: this.shouldParseSkeletons ? Xn(n) : {}
        },
        err: null
      };
    }, e.prototype.tryParsePluralOrSelectOptions = function(r, t, n, a) {
      for (var i, s = !1, o = [], u = /* @__PURE__ */ new Set(), d = a.value, c = a.location; ; ) {
        if (d.length === 0) {
          var l = this.clonePosition();
          if (t !== "select" && this.bumpIf("=")) {
            var h = this.tryParseDecimalInteger(p.EXPECT_PLURAL_ARGUMENT_SELECTOR, p.INVALID_PLURAL_ARGUMENT_SELECTOR);
            if (h.err)
              return h;
            c = b(l, this.clonePosition()), d = this.message.slice(l.offset, this.offset());
          } else
            break;
        }
        if (u.has(d))
          return this.error(t === "select" ? p.DUPLICATE_SELECT_ARGUMENT_SELECTOR : p.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, c);
        d === "other" && (s = !0), this.bumpSpace();
        var y = this.clonePosition();
        if (!this.bumpIf("{"))
          return this.error(t === "select" ? p.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : p.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, b(this.clonePosition(), this.clonePosition()));
        var m = this.parseMessage(r + 1, t, n);
        if (m.err)
          return m;
        var _ = this.tryParseArgumentClose(y);
        if (_.err)
          return _;
        o.push([
          d,
          {
            value: m.val,
            location: b(y, this.clonePosition())
          }
        ]), u.add(d), this.bumpSpace(), i = this.parseIdentifierIfPossible(), d = i.value, c = i.location;
      }
      return o.length === 0 ? this.error(t === "select" ? p.EXPECT_SELECT_ARGUMENT_SELECTOR : p.EXPECT_PLURAL_ARGUMENT_SELECTOR, b(this.clonePosition(), this.clonePosition())) : this.requiresOtherClause && !s ? this.error(p.MISSING_OTHER_CLAUSE, b(this.clonePosition(), this.clonePosition())) : { val: o, err: null };
    }, e.prototype.tryParseDecimalInteger = function(r, t) {
      var n = 1, a = this.clonePosition();
      this.bumpIf("+") || this.bumpIf("-") && (n = -1);
      for (var i = !1, s = 0; !this.isEOF(); ) {
        var o = this.char();
        if (o >= 48 && o <= 57)
          i = !0, s = s * 10 + (o - 48), this.bump();
        else
          break;
      }
      var u = b(a, this.clonePosition());
      return i ? (s *= n, oa(s) ? { val: s, err: null } : this.error(t, u)) : this.error(r, u);
    }, e.prototype.offset = function() {
      return this.position.offset;
    }, e.prototype.isEOF = function() {
      return this.offset() === this.message.length;
    }, e.prototype.clonePosition = function() {
      return {
        offset: this.position.offset,
        line: this.position.line,
        column: this.position.column
      };
    }, e.prototype.char = function() {
      var r = this.position.offset;
      if (r >= this.message.length)
        throw Error("out of bound");
      var t = cn(this.message, r);
      if (t === void 0)
        throw Error("Offset ".concat(r, " is at invalid UTF-16 code unit boundary"));
      return t;
    }, e.prototype.error = function(r, t) {
      return {
        val: null,
        err: {
          kind: r,
          message: this.message,
          location: t
        }
      };
    }, e.prototype.bump = function() {
      if (!this.isEOF()) {
        var r = this.char();
        r === 10 ? (this.position.line += 1, this.position.column = 1, this.position.offset += 1) : (this.position.column += 1, this.position.offset += r < 65536 ? 1 : 2);
      }
    }, e.prototype.bumpIf = function(r) {
      if (Fr(this.message, r, this.offset())) {
        for (var t = 0; t < r.length; t++)
          this.bump();
        return !0;
      }
      return !1;
    }, e.prototype.bumpUntil = function(r) {
      var t = this.offset(), n = this.message.indexOf(r, t);
      return n >= 0 ? (this.bumpTo(n), !0) : (this.bumpTo(this.message.length), !1);
    }, e.prototype.bumpTo = function(r) {
      if (this.offset() > r)
        throw Error("targetOffset ".concat(r, " must be greater than or equal to the current offset ").concat(this.offset()));
      for (r = Math.min(r, this.message.length); ; ) {
        var t = this.offset();
        if (t === r)
          break;
        if (t > r)
          throw Error("targetOffset ".concat(r, " is at invalid UTF-16 code unit boundary"));
        if (this.bump(), this.isEOF())
          break;
      }
    }, e.prototype.bumpSpace = function() {
      for (; !this.isEOF() && ln(this.char()); )
        this.bump();
    }, e.prototype.peek = function() {
      if (this.isEOF())
        return null;
      var r = this.char(), t = this.offset(), n = this.message.charCodeAt(t + (r >= 65536 ? 2 : 1));
      return n != null ? n : null;
    }, e;
  }()
);
function Tr(e) {
  return e >= 97 && e <= 122 || e >= 65 && e <= 90;
}
function la(e) {
  return Tr(e) || e === 47;
}
function _a(e) {
  return e === 45 || e === 46 || e >= 48 && e <= 57 || e === 95 || e >= 97 && e <= 122 || e >= 65 && e <= 90 || e == 183 || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 893 || e >= 895 && e <= 8191 || e >= 8204 && e <= 8205 || e >= 8255 && e <= 8256 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
}
function ln(e) {
  return e >= 9 && e <= 13 || e === 32 || e === 133 || e >= 8206 && e <= 8207 || e === 8232 || e === 8233;
}
function fa(e) {
  return e >= 33 && e <= 35 || e === 36 || e >= 37 && e <= 39 || e === 40 || e === 41 || e === 42 || e === 43 || e === 44 || e === 45 || e >= 46 && e <= 47 || e >= 58 && e <= 59 || e >= 60 && e <= 62 || e >= 63 && e <= 64 || e === 91 || e === 92 || e === 93 || e === 94 || e === 96 || e === 123 || e === 124 || e === 125 || e === 126 || e === 161 || e >= 162 && e <= 165 || e === 166 || e === 167 || e === 169 || e === 171 || e === 172 || e === 174 || e === 176 || e === 177 || e === 182 || e === 187 || e === 191 || e === 215 || e === 247 || e >= 8208 && e <= 8213 || e >= 8214 && e <= 8215 || e === 8216 || e === 8217 || e === 8218 || e >= 8219 && e <= 8220 || e === 8221 || e === 8222 || e === 8223 || e >= 8224 && e <= 8231 || e >= 8240 && e <= 8248 || e === 8249 || e === 8250 || e >= 8251 && e <= 8254 || e >= 8257 && e <= 8259 || e === 8260 || e === 8261 || e === 8262 || e >= 8263 && e <= 8273 || e === 8274 || e === 8275 || e >= 8277 && e <= 8286 || e >= 8592 && e <= 8596 || e >= 8597 && e <= 8601 || e >= 8602 && e <= 8603 || e >= 8604 && e <= 8607 || e === 8608 || e >= 8609 && e <= 8610 || e === 8611 || e >= 8612 && e <= 8613 || e === 8614 || e >= 8615 && e <= 8621 || e === 8622 || e >= 8623 && e <= 8653 || e >= 8654 && e <= 8655 || e >= 8656 && e <= 8657 || e === 8658 || e === 8659 || e === 8660 || e >= 8661 && e <= 8691 || e >= 8692 && e <= 8959 || e >= 8960 && e <= 8967 || e === 8968 || e === 8969 || e === 8970 || e === 8971 || e >= 8972 && e <= 8991 || e >= 8992 && e <= 8993 || e >= 8994 && e <= 9e3 || e === 9001 || e === 9002 || e >= 9003 && e <= 9083 || e === 9084 || e >= 9085 && e <= 9114 || e >= 9115 && e <= 9139 || e >= 9140 && e <= 9179 || e >= 9180 && e <= 9185 || e >= 9186 && e <= 9254 || e >= 9255 && e <= 9279 || e >= 9280 && e <= 9290 || e >= 9291 && e <= 9311 || e >= 9472 && e <= 9654 || e === 9655 || e >= 9656 && e <= 9664 || e === 9665 || e >= 9666 && e <= 9719 || e >= 9720 && e <= 9727 || e >= 9728 && e <= 9838 || e === 9839 || e >= 9840 && e <= 10087 || e === 10088 || e === 10089 || e === 10090 || e === 10091 || e === 10092 || e === 10093 || e === 10094 || e === 10095 || e === 10096 || e === 10097 || e === 10098 || e === 10099 || e === 10100 || e === 10101 || e >= 10132 && e <= 10175 || e >= 10176 && e <= 10180 || e === 10181 || e === 10182 || e >= 10183 && e <= 10213 || e === 10214 || e === 10215 || e === 10216 || e === 10217 || e === 10218 || e === 10219 || e === 10220 || e === 10221 || e === 10222 || e === 10223 || e >= 10224 && e <= 10239 || e >= 10240 && e <= 10495 || e >= 10496 && e <= 10626 || e === 10627 || e === 10628 || e === 10629 || e === 10630 || e === 10631 || e === 10632 || e === 10633 || e === 10634 || e === 10635 || e === 10636 || e === 10637 || e === 10638 || e === 10639 || e === 10640 || e === 10641 || e === 10642 || e === 10643 || e === 10644 || e === 10645 || e === 10646 || e === 10647 || e === 10648 || e >= 10649 && e <= 10711 || e === 10712 || e === 10713 || e === 10714 || e === 10715 || e >= 10716 && e <= 10747 || e === 10748 || e === 10749 || e >= 10750 && e <= 11007 || e >= 11008 && e <= 11055 || e >= 11056 && e <= 11076 || e >= 11077 && e <= 11078 || e >= 11079 && e <= 11084 || e >= 11085 && e <= 11123 || e >= 11124 && e <= 11125 || e >= 11126 && e <= 11157 || e === 11158 || e >= 11159 && e <= 11263 || e >= 11776 && e <= 11777 || e === 11778 || e === 11779 || e === 11780 || e === 11781 || e >= 11782 && e <= 11784 || e === 11785 || e === 11786 || e === 11787 || e === 11788 || e === 11789 || e >= 11790 && e <= 11798 || e === 11799 || e >= 11800 && e <= 11801 || e === 11802 || e === 11803 || e === 11804 || e === 11805 || e >= 11806 && e <= 11807 || e === 11808 || e === 11809 || e === 11810 || e === 11811 || e === 11812 || e === 11813 || e === 11814 || e === 11815 || e === 11816 || e === 11817 || e >= 11818 && e <= 11822 || e === 11823 || e >= 11824 && e <= 11833 || e >= 11834 && e <= 11835 || e >= 11836 && e <= 11839 || e === 11840 || e === 11841 || e === 11842 || e >= 11843 && e <= 11855 || e >= 11856 && e <= 11857 || e === 11858 || e >= 11859 && e <= 11903 || e >= 12289 && e <= 12291 || e === 12296 || e === 12297 || e === 12298 || e === 12299 || e === 12300 || e === 12301 || e === 12302 || e === 12303 || e === 12304 || e === 12305 || e >= 12306 && e <= 12307 || e === 12308 || e === 12309 || e === 12310 || e === 12311 || e === 12312 || e === 12313 || e === 12314 || e === 12315 || e === 12316 || e === 12317 || e >= 12318 && e <= 12319 || e === 12320 || e === 12336 || e === 64830 || e === 64831 || e >= 65093 && e <= 65094;
}
function Sr(e) {
  e.forEach(function(r) {
    if (delete r.location, rn(r) || tn(r))
      for (var t in r.options)
        delete r.options[t].location, Sr(r.options[t].value);
    else $t(r) && an(r.style) || (Qt(r) || en(r)) && pr(r.style) ? delete r.style.location : nn(r) && Sr(r.children);
  });
}
function ma(e, r) {
  r === void 0 && (r = {}), r = f({ shouldParseSkeletons: !0, requiresOtherClause: !0 }, r);
  var t = new ha(e, r).parse();
  if (t.err) {
    var n = SyntaxError(p[t.err.kind]);
    throw n.location = t.err.location, n.originalMessage = t.err.message, n;
  }
  return r != null && r.captureLocation || Sr(t.val), t.val;
}
var P;
(function(e) {
  e.MISSING_VALUE = "MISSING_VALUE", e.INVALID_VALUE = "INVALID_VALUE", e.MISSING_INTL_API = "MISSING_INTL_API";
})(P || (P = {}));
var q = (
  /** @class */
  function(e) {
    R(r, e);
    function r(t, n, a) {
      var i = e.call(this, t) || this;
      return i.code = n, i.originalMessage = a, i;
    }
    return r.prototype.toString = function() {
      return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    }, r;
  }(Error)
), jr = (
  /** @class */
  function(e) {
    R(r, e);
    function r(t, n, a, i) {
      return e.call(this, 'Invalid values for "'.concat(t, '": "').concat(n, '". Options are "').concat(Object.keys(a).join('", "'), '"'), P.INVALID_VALUE, i) || this;
    }
    return r;
  }(q)
), ya = (
  /** @class */
  function(e) {
    R(r, e);
    function r(t, n, a) {
      return e.call(this, 'Value for "'.concat(t, '" must be of type ').concat(n), P.INVALID_VALUE, a) || this;
    }
    return r;
  }(q)
), va = (
  /** @class */
  function(e) {
    R(r, e);
    function r(t, n) {
      return e.call(this, 'The intl string context variable "'.concat(t, '" was not provided to the string "').concat(n, '"'), P.MISSING_VALUE, n) || this;
    }
    return r;
  }(q)
), M;
(function(e) {
  e[e.literal = 0] = "literal", e[e.object = 1] = "object";
})(M || (M = {}));
function ga(e) {
  return e.length < 2 ? e : e.reduce(function(r, t) {
    var n = r[r.length - 1];
    return !n || n.type !== M.literal || t.type !== M.literal ? r.push(t) : n.value += t.value, r;
  }, []);
}
function pa(e) {
  return typeof e == "function";
}
function ae(e, r, t, n, a, i, s) {
  if (e.length === 1 && Pr(e[0]))
    return [
      {
        type: M.literal,
        value: e[0].value
      }
    ];
  for (var o = [], u = 0, d = e; u < d.length; u++) {
    var c = d[u];
    if (Pr(c)) {
      o.push({
        type: M.literal,
        value: c.value
      });
      continue;
    }
    if (qn(c)) {
      typeof i == "number" && o.push({
        type: M.literal,
        value: t.getNumberFormat(r).format(i)
      });
      continue;
    }
    var l = c.value;
    if (!(a && l in a))
      throw new va(l, s);
    var h = a[l];
    if (Un(c)) {
      (!h || typeof h == "string" || typeof h == "number") && (h = typeof h == "string" || typeof h == "number" ? String(h) : ""), o.push({
        type: typeof h == "string" ? M.literal : M.object,
        value: h
      });
      continue;
    }
    if (Qt(c)) {
      var y = typeof c.style == "string" ? n.date[c.style] : pr(c.style) ? c.style.parsedOptions : void 0;
      o.push({
        type: M.literal,
        value: t.getDateTimeFormat(r, y).format(h)
      });
      continue;
    }
    if (en(c)) {
      var y = typeof c.style == "string" ? n.time[c.style] : pr(c.style) ? c.style.parsedOptions : n.time.medium;
      o.push({
        type: M.literal,
        value: t.getDateTimeFormat(r, y).format(h)
      });
      continue;
    }
    if ($t(c)) {
      var y = typeof c.style == "string" ? n.number[c.style] : an(c.style) ? c.style.parsedOptions : void 0;
      y && y.scale && (h = h * (y.scale || 1)), o.push({
        type: M.literal,
        value: t.getNumberFormat(r, y).format(h)
      });
      continue;
    }
    if (nn(c)) {
      var m = c.children, _ = c.value, v = a[_];
      if (!pa(v))
        throw new ya(_, "function", s);
      var g = ae(m, r, t, n, a, i), E = v(g.map(function(H) {
        return H.value;
      }));
      Array.isArray(E) || (E = [E]), o.push.apply(o, E.map(function(H) {
        return {
          type: typeof H == "string" ? M.literal : M.object,
          value: H
        };
      }));
    }
    if (rn(c)) {
      var T = c.options[h] || c.options.other;
      if (!T)
        throw new jr(c.value, h, Object.keys(c.options), s);
      o.push.apply(o, ae(T.value, r, t, n, a));
      continue;
    }
    if (tn(c)) {
      var T = c.options["=".concat(h)];
      if (!T) {
        if (!Intl.PluralRules)
          throw new q(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, P.MISSING_INTL_API, s);
        var S = t.getPluralRules(r, { type: c.pluralType }).select(h - (c.offset || 0));
        T = c.options[S] || c.options.other;
      }
      if (!T)
        throw new jr(c.value, h, Object.keys(c.options), s);
      o.push.apply(o, ae(T.value, r, t, n, a, h - (c.offset || 0)));
      continue;
    }
  }
  return ga(o);
}
function ba(e, r) {
  return r ? f(f(f({}, e || {}), r || {}), Object.keys(e).reduce(function(t, n) {
    return t[n] = f(f({}, e[n]), r[n] || {}), t;
  }, {})) : e;
}
function Ea(e, r) {
  return r ? Object.keys(e).reduce(function(t, n) {
    return t[n] = ba(e[n], r[n]), t;
  }, f({}, e)) : e;
}
function fe(e) {
  return {
    create: function() {
      return {
        get: function(r) {
          return e[r];
        },
        set: function(r, t) {
          e[r] = t;
        }
      };
    }
  };
}
function wa(e) {
  return e === void 0 && (e = {
    number: {},
    dateTime: {},
    pluralRules: {}
  }), {
    getNumberFormat: C(function() {
      for (var r, t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      return new ((r = Intl.NumberFormat).bind.apply(r, x([void 0], t, !1)))();
    }, {
      cache: fe(e.number),
      strategy: A.variadic
    }),
    getDateTimeFormat: C(function() {
      for (var r, t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      return new ((r = Intl.DateTimeFormat).bind.apply(r, x([void 0], t, !1)))();
    }, {
      cache: fe(e.dateTime),
      strategy: A.variadic
    }),
    getPluralRules: C(function() {
      for (var r, t = [], n = 0; n < arguments.length; n++)
        t[n] = arguments[n];
      return new ((r = Intl.PluralRules).bind.apply(r, x([void 0], t, !1)))();
    }, {
      cache: fe(e.pluralRules),
      strategy: A.variadic
    })
  };
}
var _n = (
  /** @class */
  function() {
    function e(r, t, n, a) {
      t === void 0 && (t = e.defaultLocale);
      var i = this;
      if (this.formatterCache = {
        number: {},
        dateTime: {},
        pluralRules: {}
      }, this.format = function(u) {
        var d = i.formatToParts(u);
        if (d.length === 1)
          return d[0].value;
        var c = d.reduce(function(l, h) {
          return !l.length || h.type !== M.literal || typeof l[l.length - 1] != "string" ? l.push(h.value) : l[l.length - 1] += h.value, l;
        }, []);
        return c.length <= 1 ? c[0] || "" : c;
      }, this.formatToParts = function(u) {
        return ae(i.ast, i.locales, i.formatters, i.formats, u, void 0, i.message);
      }, this.resolvedOptions = function() {
        var u;
        return {
          locale: ((u = i.resolvedLocale) === null || u === void 0 ? void 0 : u.toString()) || Intl.NumberFormat.supportedLocalesOf(i.locales)[0]
        };
      }, this.getAst = function() {
        return i.ast;
      }, this.locales = t, this.resolvedLocale = e.resolveLocale(t), typeof r == "string") {
        if (this.message = r, !e.__parse)
          throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
        var s = a || {};
        s.formatters;
        var o = Rn(s, ["formatters"]);
        this.ast = e.__parse(r, f(f({}, o), { locale: this.resolvedLocale }));
      } else
        this.ast = r;
      if (!Array.isArray(this.ast))
        throw new TypeError("A message must be provided as a String or AST.");
      this.formats = Ea(e.formats, n), this.formatters = a && a.formatters || wa(this.formatterCache);
    }
    return Object.defineProperty(e, "defaultLocale", {
      get: function() {
        return e.memoizedDefaultLocale || (e.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale), e.memoizedDefaultLocale;
      },
      enumerable: !1,
      configurable: !0
    }), e.memoizedDefaultLocale = null, e.resolveLocale = function(r) {
      if (typeof Intl.Locale != "undefined") {
        var t = Intl.NumberFormat.supportedLocalesOf(r);
        return t.length > 0 ? new Intl.Locale(t[0]) : new Intl.Locale(typeof r == "string" ? r : r[0]);
      }
    }, e.__parse = ma, e.formats = {
      number: {
        integer: {
          maximumFractionDigits: 0
        },
        currency: {
          style: "currency"
        },
        percent: {
          style: "percent"
        }
      },
      date: {
        short: {
          month: "numeric",
          day: "numeric",
          year: "2-digit"
        },
        medium: {
          month: "short",
          day: "numeric",
          year: "numeric"
        },
        long: {
          month: "long",
          day: "numeric",
          year: "numeric"
        },
        full: {
          weekday: "long",
          month: "long",
          day: "numeric",
          year: "numeric"
        }
      },
      time: {
        short: {
          hour: "numeric",
          minute: "numeric"
        },
        medium: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric"
        },
        long: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        },
        full: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        }
      }
    }, e;
  }()
), K;
(function(e) {
  e.FORMAT_ERROR = "FORMAT_ERROR", e.UNSUPPORTED_FORMATTER = "UNSUPPORTED_FORMATTER", e.INVALID_CONFIG = "INVALID_CONFIG", e.MISSING_DATA = "MISSING_DATA", e.MISSING_TRANSLATION = "MISSING_TRANSLATION";
})(K || (K = {}));
var $ = (
  /** @class */
  function(e) {
    R(r, e);
    function r(t, n, a) {
      var i = this, s = a ? a instanceof Error ? a : new Error(String(a)) : void 0;
      return i = e.call(this, "[@formatjs/intl Error ".concat(t, "] ").concat(n, `
`).concat(s ? `
`.concat(s.message, `
`).concat(s.stack) : "")) || this, i.code = t, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(i, r), i;
    }
    return r;
  }(Error)
), Ta = (
  /** @class */
  function(e) {
    R(r, e);
    function r(t, n) {
      return e.call(this, K.UNSUPPORTED_FORMATTER, t, n) || this;
    }
    return r;
  }($)
), Sa = (
  /** @class */
  function(e) {
    R(r, e);
    function r(t, n) {
      return e.call(this, K.INVALID_CONFIG, t, n) || this;
    }
    return r;
  }($)
), Vr = (
  /** @class */
  function(e) {
    R(r, e);
    function r(t, n) {
      return e.call(this, K.MISSING_DATA, t, n) || this;
    }
    return r;
  }($)
), N = (
  /** @class */
  function(e) {
    R(r, e);
    function r(t, n, a) {
      var i = e.call(this, K.FORMAT_ERROR, "".concat(t, `
Locale: `).concat(n, `
`), a) || this;
      return i.locale = n, i;
    }
    return r;
  }($)
), me = (
  /** @class */
  function(e) {
    R(r, e);
    function r(t, n, a, i) {
      var s = e.call(this, "".concat(t, `
MessageID: `).concat(a == null ? void 0 : a.id, `
Default Message: `).concat(a == null ? void 0 : a.defaultMessage, `
Description: `).concat(a == null ? void 0 : a.description, `
`), n, i) || this;
      return s.descriptor = a, s.locale = n, s;
    }
    return r;
  }(N)
), xa = (
  /** @class */
  function(e) {
    R(r, e);
    function r(t, n) {
      var a = e.call(this, K.MISSING_TRANSLATION, 'Missing message: "'.concat(t.id, '" for locale "').concat(n, '", using ').concat(t.defaultMessage ? "default message (".concat(typeof t.defaultMessage == "string" ? t.defaultMessage : t.defaultMessage.map(function(i) {
        var s;
        return (s = i.value) !== null && s !== void 0 ? s : JSON.stringify(i);
      }).join(), ")") : "id", " as fallback.")) || this;
      return a.descriptor = t, a;
    }
    return r;
  }($)
);
function z(e, r, t) {
  return t === void 0 && (t = {}), r.reduce(function(n, a) {
    return a in e ? n[a] = e[a] : a in t && (n[a] = t[a]), n;
  }, {});
}
var Ma = function(e) {
  process.env.NODE_ENV !== "production" && console.error(e);
}, Ca = function(e) {
  process.env.NODE_ENV !== "production" && console.warn(e);
}, Aa = {
  formats: {},
  messages: {},
  timeZone: void 0,
  defaultLocale: "en",
  defaultFormats: {},
  fallbackOnEmptyString: !0,
  onError: Ma,
  onWarn: Ca
};
function fn() {
  return {
    dateTime: {},
    number: {},
    message: {},
    relativeTime: {},
    pluralRules: {},
    list: {},
    displayNames: {}
  };
}
function V(e) {
  return {
    create: function() {
      return {
        get: function(r) {
          return e[r];
        },
        set: function(r, t) {
          e[r] = t;
        }
      };
    }
  };
}
function Ia(e) {
  e === void 0 && (e = fn());
  var r = Intl.RelativeTimeFormat, t = Intl.ListFormat, n = Intl.DisplayNames, a = C(function() {
    for (var o, u = [], d = 0; d < arguments.length; d++)
      u[d] = arguments[d];
    return new ((o = Intl.DateTimeFormat).bind.apply(o, x([void 0], u, !1)))();
  }, {
    cache: V(e.dateTime),
    strategy: A.variadic
  }), i = C(function() {
    for (var o, u = [], d = 0; d < arguments.length; d++)
      u[d] = arguments[d];
    return new ((o = Intl.NumberFormat).bind.apply(o, x([void 0], u, !1)))();
  }, {
    cache: V(e.number),
    strategy: A.variadic
  }), s = C(function() {
    for (var o, u = [], d = 0; d < arguments.length; d++)
      u[d] = arguments[d];
    return new ((o = Intl.PluralRules).bind.apply(o, x([void 0], u, !1)))();
  }, {
    cache: V(e.pluralRules),
    strategy: A.variadic
  });
  return {
    getDateTimeFormat: a,
    getNumberFormat: i,
    getMessageFormat: C(function(o, u, d, c) {
      return new _n(o, u, d, f({ formatters: {
        getNumberFormat: i,
        getDateTimeFormat: a,
        getPluralRules: s
      } }, c || {}));
    }, {
      cache: V(e.message),
      strategy: A.variadic
    }),
    getRelativeTimeFormat: C(function() {
      for (var o = [], u = 0; u < arguments.length; u++)
        o[u] = arguments[u];
      return new (r.bind.apply(r, x([void 0], o, !1)))();
    }, {
      cache: V(e.relativeTime),
      strategy: A.variadic
    }),
    getPluralRules: s,
    getListFormat: C(function() {
      for (var o = [], u = 0; u < arguments.length; u++)
        o[u] = arguments[u];
      return new (t.bind.apply(t, x([void 0], o, !1)))();
    }, {
      cache: V(e.list),
      strategy: A.variadic
    }),
    getDisplayNames: C(function() {
      for (var o = [], u = 0; u < arguments.length; u++)
        o[u] = arguments[u];
      return new (n.bind.apply(n, x([void 0], o, !1)))();
    }, {
      cache: V(e.displayNames),
      strategy: A.variadic
    })
  };
}
function Mr(e, r, t, n) {
  var a = e && e[r], i;
  if (a && (i = a[t]), i)
    return i;
  n(new Ta("No ".concat(r, " format named: ").concat(t)));
}
function La(e, r, t) {
  if (t === void 0 && (t = Error), !e)
    throw new t(r);
}
C(function() {
  for (var e, r = [], t = 0; t < arguments.length; t++)
    r[t] = arguments[t];
  return new ((e = Intl.NumberFormat).bind.apply(e, x([void 0], r, !1)))();
}, {
  strategy: A.variadic
});
C(function() {
  for (var e, r = [], t = 0; t < arguments.length; t++)
    r[t] = arguments[t];
  return new ((e = Intl.DateTimeFormat).bind.apply(e, x([void 0], r, !1)))();
}, {
  strategy: A.variadic
});
C(function() {
  for (var e, r = [], t = 0; t < arguments.length; t++)
    r[t] = arguments[t];
  return new ((e = Intl.PluralRules).bind.apply(e, x([void 0], r, !1)))();
}, {
  strategy: A.variadic
});
C(function() {
  for (var e, r = [], t = 0; t < arguments.length; t++)
    r[t] = arguments[t];
  return new ((e = Intl.Locale).bind.apply(e, x([void 0], r, !1)))();
}, {
  strategy: A.variadic
});
C(function() {
  for (var e, r = [], t = 0; t < arguments.length; t++)
    r[t] = arguments[t];
  return new ((e = Intl.ListFormat).bind.apply(e, x([void 0], r, !1)))();
}, {
  strategy: A.variadic
});
function re(e, r) {
  return Object.keys(e).reduce(function(t, n) {
    return t[n] = f({ timeZone: r }, e[n]), t;
  }, {});
}
function kr(e, r) {
  var t = Object.keys(f(f({}, e), r));
  return t.reduce(function(n, a) {
    return n[a] = f(f({}, e[a] || {}), r[a] || {}), n;
  }, {});
}
function Kr(e, r) {
  if (!r)
    return e;
  var t = _n.formats;
  return f(f(f({}, t), e), { date: kr(re(t.date, r), re(e.date || {}, r)), time: kr(re(t.time, r), re(e.time || {}, r)) });
}
var zr = function(e, r, t, n, a) {
  var i = e.locale, s = e.formats, o = e.messages, u = e.defaultLocale, d = e.defaultFormats, c = e.fallbackOnEmptyString, l = e.onError, h = e.timeZone, y = e.defaultRichTextElements;
  t === void 0 && (t = { id: "" });
  var m = t.id, _ = t.defaultMessage;
  La(!!m, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
  var v = String(m), g = (
    // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    o && Object.prototype.hasOwnProperty.call(o, v) && o[v]
  );
  if (Array.isArray(g) && g.length === 1 && g[0].type === w.literal)
    return g[0].value;
  if (!n && g && typeof g == "string" && !y)
    return g.replace(/'\{(.*?)\}'/gi, "{$1}");
  if (n = f(f({}, y), n || {}), s = Kr(s, h), d = Kr(d, h), !g) {
    if (c === !1 && g === "")
      return g;
    if ((!_ || i && i.toLowerCase() !== u.toLowerCase()) && l(new xa(t, i)), _)
      try {
        var E = r.getMessageFormat(_, u, d, a);
        return E.format(n);
      } catch (T) {
        return l(new me('Error formatting default message for: "'.concat(v, '", rendering default message verbatim'), i, t, T)), typeof _ == "string" ? _ : v;
      }
    return v;
  }
  try {
    var E = r.getMessageFormat(g, i, s, f({ formatters: r }, a || {}));
    return E.format(n);
  } catch (T) {
    l(new me('Error formatting message: "'.concat(v, '", using ').concat(_ ? "default message" : "id", " as fallback."), i, t, T));
  }
  if (_)
    try {
      var E = r.getMessageFormat(_, u, d, a);
      return E.format(n);
    } catch (T) {
      l(new me('Error formatting the default message for: "'.concat(v, '", rendering message verbatim'), i, t, T));
    }
  return typeof g == "string" ? g : typeof _ == "string" ? _ : v;
}, mn = [
  "formatMatcher",
  "timeZone",
  "hour12",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "hourCycle",
  "dateStyle",
  "timeStyle",
  "calendar",
  // 'dayPeriod',
  "numberingSystem",
  "fractionalSecondDigits"
];
function ie(e, r, t, n) {
  var a = e.locale, i = e.formats, s = e.onError, o = e.timeZone;
  n === void 0 && (n = {});
  var u = n.format, d = f(f({}, o && { timeZone: o }), u && Mr(i, r, u, s)), c = z(n, mn, d);
  return r === "time" && !c.hour && !c.minute && !c.second && !c.timeStyle && !c.dateStyle && (c = f(f({}, c), { hour: "numeric", minute: "numeric" })), t(a, c);
}
function Ha(e, r) {
  for (var t = [], n = 2; n < arguments.length; n++)
    t[n - 2] = arguments[n];
  var a = t[0], i = t[1], s = i === void 0 ? {} : i, o = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return ie(e, "date", r, s).format(o);
  } catch (u) {
    e.onError(new N("Error formatting date.", e.locale, u));
  }
  return String(o);
}
function Na(e, r) {
  for (var t = [], n = 2; n < arguments.length; n++)
    t[n - 2] = arguments[n];
  var a = t[0], i = t[1], s = i === void 0 ? {} : i, o = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return ie(e, "time", r, s).format(o);
  } catch (u) {
    e.onError(new N("Error formatting time.", e.locale, u));
  }
  return String(o);
}
function Ra(e, r) {
  for (var t = [], n = 2; n < arguments.length; n++)
    t[n - 2] = arguments[n];
  var a = t[0], i = t[1], s = t[2], o = s === void 0 ? {} : s, u = e.timeZone, d = e.locale, c = e.onError, l = z(o, mn, u ? { timeZone: u } : {});
  try {
    return r(d, l).formatRange(a, i);
  } catch (h) {
    c(new N("Error formatting date time range.", e.locale, h));
  }
  return String(a);
}
function Ba(e, r) {
  for (var t = [], n = 2; n < arguments.length; n++)
    t[n - 2] = arguments[n];
  var a = t[0], i = t[1], s = i === void 0 ? {} : i, o = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return ie(e, "date", r, s).formatToParts(o);
  } catch (u) {
    e.onError(new N("Error formatting date.", e.locale, u));
  }
  return [];
}
function Pa(e, r) {
  for (var t = [], n = 2; n < arguments.length; n++)
    t[n - 2] = arguments[n];
  var a = t[0], i = t[1], s = i === void 0 ? {} : i, o = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return ie(e, "time", r, s).formatToParts(o);
  } catch (u) {
    e.onError(new N("Error formatting time.", e.locale, u));
  }
  return [];
}
var Oa = [
  "style",
  "type",
  "fallback",
  "languageDisplay"
];
function Ga(e, r, t, n) {
  var a = e.locale, i = e.onError, s = Intl.DisplayNames;
  s || i(new q(`Intl.DisplayNames is not available in this environment.
Try polyfilling it using "@formatjs/intl-displaynames"
`, P.MISSING_INTL_API));
  var o = z(n, Oa);
  try {
    return r(a, o).of(t);
  } catch (u) {
    i(new N("Error formatting display name.", a, u));
  }
}
var Da = [
  "type",
  "style"
], Zr = Date.now();
function Fa(e) {
  return "".concat(Zr, "_").concat(e, "_").concat(Zr);
}
function Ua(e, r, t, n) {
  n === void 0 && (n = {});
  var a = yn(e, r, t, n).reduce(function(i, s) {
    var o = s.value;
    return typeof o != "string" ? i.push(o) : typeof i[i.length - 1] == "string" ? i[i.length - 1] += o : i.push(o), i;
  }, []);
  return a.length === 1 ? a[0] : a.length === 0 ? "" : a;
}
function yn(e, r, t, n) {
  var a = e.locale, i = e.onError;
  n === void 0 && (n = {});
  var s = Intl.ListFormat;
  s || i(new q(`Intl.ListFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-listformat"
`, P.MISSING_INTL_API));
  var o = z(n, Da);
  try {
    var u = {}, d = t.map(function(c, l) {
      if (typeof c == "object") {
        var h = Fa(l);
        return u[h] = c, h;
      }
      return String(c);
    });
    return r(a, o).formatToParts(d).map(function(c) {
      return c.type === "literal" ? c : f(f({}, c), { value: u[c.value] || c.value });
    });
  } catch (c) {
    i(new N("Error formatting list.", a, c));
  }
  return t;
}
var qa = ["type"];
function ja(e, r, t, n) {
  var a = e.locale, i = e.onError;
  n === void 0 && (n = {}), Intl.PluralRules || i(new q(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, P.MISSING_INTL_API));
  var s = z(n, qa);
  try {
    return r(a, s).select(t);
  } catch (o) {
    i(new N("Error formatting plural.", a, o));
  }
  return "other";
}
var Va = ["numeric", "style"];
function ka(e, r, t) {
  var n = e.locale, a = e.formats, i = e.onError;
  t === void 0 && (t = {});
  var s = t.format, o = !!s && Mr(a, "relative", s, i) || {}, u = z(t, Va, o);
  return r(n, u);
}
function Ka(e, r, t, n, a) {
  a === void 0 && (a = {}), n || (n = "second");
  var i = Intl.RelativeTimeFormat;
  i || e.onError(new q(`Intl.RelativeTimeFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-relativetimeformat"
`, P.MISSING_INTL_API));
  try {
    return ka(e, r, a).format(t, n);
  } catch (s) {
    e.onError(new N("Error formatting relative time.", e.locale, s));
  }
  return String(t);
}
var za = [
  "style",
  "currency",
  "unit",
  "unitDisplay",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  // ES2020 NumberFormat
  "compactDisplay",
  "currencyDisplay",
  "currencySign",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "numberingSystem",
  // ES2023 NumberFormat
  "trailingZeroDisplay",
  "roundingPriority",
  "roundingIncrement",
  "roundingMode"
];
function vn(e, r, t) {
  var n = e.locale, a = e.formats, i = e.onError;
  t === void 0 && (t = {});
  var s = t.format, o = s && Mr(a, "number", s, i) || {}, u = z(t, za, o);
  return r(n, u);
}
function Za(e, r, t, n) {
  n === void 0 && (n = {});
  try {
    return vn(e, r, n).format(t);
  } catch (a) {
    e.onError(new N("Error formatting number.", e.locale, a));
  }
  return String(t);
}
function Wa(e, r, t, n) {
  n === void 0 && (n = {});
  try {
    return vn(e, r, n).formatToParts(t);
  } catch (a) {
    e.onError(new N("Error formatting number.", e.locale, a));
  }
  return [];
}
function Xa(e) {
  var r = e ? e[Object.keys(e)[0]] : void 0;
  return typeof r == "string";
}
function Ja(e) {
  e.onWarn && e.defaultRichTextElements && Xa(e.messages || {}) && e.onWarn(`[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. 
Please consider using "@formatjs/cli" to pre-compile your messages for performance.
For more details see https://formatjs.io/docs/getting-started/message-distribution`);
}
function Ya(e, r) {
  var t = Ia(r), n = f(f({}, Aa), e), a = n.locale, i = n.defaultLocale, s = n.onError;
  return a ? !Intl.NumberFormat.supportedLocalesOf(a).length && s ? s(new Vr('Missing locale data for locale: "'.concat(a, '" in Intl.NumberFormat. Using default locale: "').concat(i, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details'))) : !Intl.DateTimeFormat.supportedLocalesOf(a).length && s && s(new Vr('Missing locale data for locale: "'.concat(a, '" in Intl.DateTimeFormat. Using default locale: "').concat(i, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details'))) : (s && s(new Sa('"locale" was not configured, using "'.concat(i, '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details'))), n.locale = n.defaultLocale || "en"), Ja(n), f(f({}, n), {
    formatters: t,
    formatNumber: Za.bind(null, n, t.getNumberFormat),
    formatNumberToParts: Wa.bind(null, n, t.getNumberFormat),
    formatRelativeTime: Ka.bind(null, n, t.getRelativeTimeFormat),
    formatDate: Ha.bind(null, n, t.getDateTimeFormat),
    formatDateToParts: Ba.bind(null, n, t.getDateTimeFormat),
    formatTime: Na.bind(null, n, t.getDateTimeFormat),
    formatDateTimeRange: Ra.bind(null, n, t.getDateTimeFormat),
    formatTimeToParts: Pa.bind(null, n, t.getDateTimeFormat),
    formatPlural: ja.bind(null, n, t.getPluralRules),
    // @ts-expect-error TODO: will get to this later
    formatMessage: zr.bind(null, n, t),
    // @ts-expect-error TODO: will get to this later
    $t: zr.bind(null, n, t),
    formatList: Ua.bind(null, n, t.getListFormat),
    formatListToParts: yn.bind(null, n, t.getListFormat),
    formatDisplayName: Ga.bind(null, n, t.getDisplayNames)
  });
}
function $a(e) {
  return Intl.getCanonicalLocales(e);
}
var ye = {
  supplemental: {
    languageMatching: {
      "written-new": [
        {
          paradigmLocales: {
            _locales: "en en_GB es es_419 pt_BR pt_PT"
          }
        },
        {
          $enUS: {
            _value: "AS+CA+GU+MH+MP+PH+PR+UM+US+VI"
          }
        },
        {
          $cnsar: {
            _value: "HK+MO"
          }
        },
        {
          $americas: {
            _value: "019"
          }
        },
        {
          $maghreb: {
            _value: "MA+DZ+TN+LY+MR+EH"
          }
        },
        {
          no: {
            _desired: "nb",
            _distance: "1"
          }
        },
        {
          bs: {
            _desired: "hr",
            _distance: "4"
          }
        },
        {
          bs: {
            _desired: "sh",
            _distance: "4"
          }
        },
        {
          hr: {
            _desired: "sh",
            _distance: "4"
          }
        },
        {
          sr: {
            _desired: "sh",
            _distance: "4"
          }
        },
        {
          aa: {
            _desired: "ssy",
            _distance: "4"
          }
        },
        {
          de: {
            _desired: "gsw",
            _distance: "4",
            _oneway: "true"
          }
        },
        {
          de: {
            _desired: "lb",
            _distance: "4",
            _oneway: "true"
          }
        },
        {
          no: {
            _desired: "da",
            _distance: "8"
          }
        },
        {
          nb: {
            _desired: "da",
            _distance: "8"
          }
        },
        {
          ru: {
            _desired: "ab",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ach",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          nl: {
            _desired: "af",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ak",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "am",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          es: {
            _desired: "ay",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "az",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ur: {
            _desired: "bal",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "be",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "bem",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          hi: {
            _desired: "bh",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "bn",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "bo",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "br",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          es: {
            _desired: "ca",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          fil: {
            _desired: "ceb",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "chr",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ckb",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "co",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "crs",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          sk: {
            _desired: "cs",
            _distance: "20"
          }
        },
        {
          en: {
            _desired: "cy",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ee",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "eo",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          es: {
            _desired: "eu",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          da: {
            _desired: "fo",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          nl: {
            _desired: "fy",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ga",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "gaa",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "gd",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          es: {
            _desired: "gl",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          es: {
            _desired: "gn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          hi: {
            _desired: "gu",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ha",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "haw",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "ht",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "hy",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ia",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ig",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "is",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          id: {
            _desired: "jv",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ka",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "kg",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "kk",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "km",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "kn",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "kri",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          tr: {
            _desired: "ku",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "ky",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          it: {
            _desired: "la",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "lg",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "ln",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "lo",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "loz",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "lua",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          hi: {
            _desired: "mai",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "mfe",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "mg",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "mi",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ml",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "mn",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          hi: {
            _desired: "mr",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          id: {
            _desired: "ms",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "mt",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "my",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ne",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          nb: {
            _desired: "nn",
            _distance: "20"
          }
        },
        {
          no: {
            _desired: "nn",
            _distance: "20"
          }
        },
        {
          en: {
            _desired: "nso",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ny",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "nyn",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "oc",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "om",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "or",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "pa",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "pcm",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ps",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          es: {
            _desired: "qu",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          de: {
            _desired: "rm",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "rn",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "rw",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          hi: {
            _desired: "sa",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "sd",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "si",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "sn",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "so",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "sq",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "st",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          id: {
            _desired: "su",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "sw",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ta",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "te",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "tg",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ti",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "tk",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "tlh",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "tn",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "to",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "tt",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "tum",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "ug",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "uk",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "ur",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ru: {
            _desired: "uz",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          fr: {
            _desired: "wo",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "xh",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "yi",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "yo",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "za",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          en: {
            _desired: "zu",
            _distance: "30",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "aao",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "abh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "abv",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "acm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "acq",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "acw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "acx",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "acy",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "adf",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "aeb",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "aec",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "afb",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ajp",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "apc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "apd",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "arq",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ars",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ary",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "arz",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "auz",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "avl",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ayh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ayl",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ayn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ayp",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "bbz",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "pga",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "shu",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ar: {
            _desired: "ssh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          az: {
            _desired: "azb",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          et: {
            _desired: "vro",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "ffm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "fub",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "fue",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "fuf",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "fuh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "fui",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "fuq",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ff: {
            _desired: "fuv",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          gn: {
            _desired: "gnw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          gn: {
            _desired: "gui",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          gn: {
            _desired: "gun",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          gn: {
            _desired: "nhd",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          iu: {
            _desired: "ikt",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "enb",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "eyo",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "niq",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "oki",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "pko",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "sgc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "tec",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kln: {
            _desired: "tuy",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kok: {
            _desired: "gom",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          kpe: {
            _desired: "gkp",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "ida",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lkb",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lko",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lks",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lri",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lrm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lsm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lto",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lts",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "lwg",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "nle",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "nyd",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          luy: {
            _desired: "rag",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          lv: {
            _desired: "ltg",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "bhr",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "bjq",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "bmm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "bzc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "msh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "skg",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "tdx",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "tkg",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "txy",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "xmv",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mg: {
            _desired: "xmw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          mn: {
            _desired: "mvf",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "bjn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "btj",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "bve",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "bvu",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "coa",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "dup",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "hji",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "id",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "jak",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "jax",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "kvb",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "kvr",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "kxd",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "lce",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "lcf",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "liw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "max",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "meo",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "mfa",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "mfb",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "min",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "mqg",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "msi",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "mui",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "orn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "ors",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "pel",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "pse",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "tmw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "urk",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "vkk",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "vkt",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "xmm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "zlm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ms: {
            _desired: "zmi",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ne: {
            _desired: "dty",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          om: {
            _desired: "gax",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          om: {
            _desired: "hae",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          om: {
            _desired: "orc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          or: {
            _desired: "spv",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ps: {
            _desired: "pbt",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          ps: {
            _desired: "pst",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qub",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qud",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "quf",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qug",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "quh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "quk",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qul",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qup",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qur",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qus",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "quw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qux",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "quy",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qva",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qve",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvi",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvj",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvl",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvm",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvo",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvp",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvs",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qvz",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qwa",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qwc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qwh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qws",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxa",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxl",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxo",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxp",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxr",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxt",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxu",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          qu: {
            _desired: "qxw",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          sc: {
            _desired: "sdc",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          sc: {
            _desired: "sdn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          sc: {
            _desired: "sro",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          sq: {
            _desired: "aae",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          sq: {
            _desired: "aat",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          sq: {
            _desired: "aln",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          syr: {
            _desired: "aii",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          uz: {
            _desired: "uzs",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          yi: {
            _desired: "yih",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "cdo",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "cjy",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "cpx",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "czh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "czo",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "gan",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "hak",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "hsn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "lzh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "mnp",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "nan",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "wuu",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          zh: {
            _desired: "yue",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "*": {
            _desired: "*",
            _distance: "80"
          }
        },
        {
          "en-Latn": {
            _desired: "am-Ethi",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "ru-Cyrl": {
            _desired: "az-Latn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "bn-Beng",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "zh-Hans": {
            _desired: "bo-Tibt",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "ru-Cyrl": {
            _desired: "hy-Armn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "ka-Geor",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "km-Khmr",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "kn-Knda",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "lo-Laoo",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "ml-Mlym",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "my-Mymr",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "ne-Deva",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "or-Orya",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "pa-Guru",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "ps-Arab",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "sd-Arab",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "si-Sinh",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "ta-Taml",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "te-Telu",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "ti-Ethi",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "ru-Cyrl": {
            _desired: "tk-Latn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "ur-Arab",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "ru-Cyrl": {
            _desired: "uz-Latn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "en-Latn": {
            _desired: "yi-Hebr",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "sr-Cyrl": {
            _desired: "sr-Latn",
            _distance: "5"
          }
        },
        {
          "zh-Hans": {
            _desired: "za-Latn",
            _distance: "10",
            _oneway: "true"
          }
        },
        {
          "zh-Hans": {
            _desired: "zh-Hani",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "zh-Hant": {
            _desired: "zh-Hani",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "ar-Arab": {
            _desired: "ar-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "bn-Beng": {
            _desired: "bn-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "gu-Gujr": {
            _desired: "gu-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "hi-Deva": {
            _desired: "hi-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "kn-Knda": {
            _desired: "kn-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "ml-Mlym": {
            _desired: "ml-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "mr-Deva": {
            _desired: "mr-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "ta-Taml": {
            _desired: "ta-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "te-Telu": {
            _desired: "te-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "zh-Hans": {
            _desired: "zh-Latn",
            _distance: "20",
            _oneway: "true"
          }
        },
        {
          "ja-Jpan": {
            _desired: "ja-Latn",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ja-Jpan": {
            _desired: "ja-Hani",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ja-Jpan": {
            _desired: "ja-Hira",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ja-Jpan": {
            _desired: "ja-Kana",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ja-Jpan": {
            _desired: "ja-Hrkt",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ja-Hrkt": {
            _desired: "ja-Hira",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ja-Hrkt": {
            _desired: "ja-Kana",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ko-Kore": {
            _desired: "ko-Hani",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ko-Kore": {
            _desired: "ko-Hang",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ko-Kore": {
            _desired: "ko-Jamo",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "ko-Hang": {
            _desired: "ko-Jamo",
            _distance: "5",
            _oneway: "true"
          }
        },
        {
          "*-*": {
            _desired: "*-*",
            _distance: "50"
          }
        },
        {
          "ar-*-$maghreb": {
            _desired: "ar-*-$maghreb",
            _distance: "4"
          }
        },
        {
          "ar-*-$!maghreb": {
            _desired: "ar-*-$!maghreb",
            _distance: "4"
          }
        },
        {
          "ar-*-*": {
            _desired: "ar-*-*",
            _distance: "5"
          }
        },
        {
          "en-*-$enUS": {
            _desired: "en-*-$enUS",
            _distance: "4"
          }
        },
        {
          "en-*-GB": {
            _desired: "en-*-$!enUS",
            _distance: "3"
          }
        },
        {
          "en-*-$!enUS": {
            _desired: "en-*-$!enUS",
            _distance: "4"
          }
        },
        {
          "en-*-*": {
            _desired: "en-*-*",
            _distance: "5"
          }
        },
        {
          "es-*-$americas": {
            _desired: "es-*-$americas",
            _distance: "4"
          }
        },
        {
          "es-*-$!americas": {
            _desired: "es-*-$!americas",
            _distance: "4"
          }
        },
        {
          "es-*-*": {
            _desired: "es-*-*",
            _distance: "5"
          }
        },
        {
          "pt-*-$americas": {
            _desired: "pt-*-$americas",
            _distance: "4"
          }
        },
        {
          "pt-*-$!americas": {
            _desired: "pt-*-$!americas",
            _distance: "4"
          }
        },
        {
          "pt-*-*": {
            _desired: "pt-*-*",
            _distance: "5"
          }
        },
        {
          "zh-Hant-$cnsar": {
            _desired: "zh-Hant-$cnsar",
            _distance: "4"
          }
        },
        {
          "zh-Hant-$!cnsar": {
            _desired: "zh-Hant-$!cnsar",
            _distance: "4"
          }
        },
        {
          "zh-Hant-*": {
            _desired: "zh-Hant-*",
            _distance: "5"
          }
        },
        {
          "*-*-*": {
            _desired: "*-*-*",
            _distance: "4"
          }
        }
      ]
    }
  }
}, Qa = {
  "001": [
    "001",
    "001-status-grouping",
    "002",
    "005",
    "009",
    "011",
    "013",
    "014",
    "015",
    "017",
    "018",
    "019",
    "021",
    "029",
    "030",
    "034",
    "035",
    "039",
    "053",
    "054",
    "057",
    "061",
    "142",
    "143",
    "145",
    "150",
    "151",
    "154",
    "155",
    "AC",
    "AD",
    "AE",
    "AF",
    "AG",
    "AI",
    "AL",
    "AM",
    "AO",
    "AQ",
    "AR",
    "AS",
    "AT",
    "AU",
    "AW",
    "AX",
    "AZ",
    "BA",
    "BB",
    "BD",
    "BE",
    "BF",
    "BG",
    "BH",
    "BI",
    "BJ",
    "BL",
    "BM",
    "BN",
    "BO",
    "BQ",
    "BR",
    "BS",
    "BT",
    "BV",
    "BW",
    "BY",
    "BZ",
    "CA",
    "CC",
    "CD",
    "CF",
    "CG",
    "CH",
    "CI",
    "CK",
    "CL",
    "CM",
    "CN",
    "CO",
    "CP",
    "CQ",
    "CR",
    "CU",
    "CV",
    "CW",
    "CX",
    "CY",
    "CZ",
    "DE",
    "DG",
    "DJ",
    "DK",
    "DM",
    "DO",
    "DZ",
    "EA",
    "EC",
    "EE",
    "EG",
    "EH",
    "ER",
    "ES",
    "ET",
    "EU",
    "EZ",
    "FI",
    "FJ",
    "FK",
    "FM",
    "FO",
    "FR",
    "GA",
    "GB",
    "GD",
    "GE",
    "GF",
    "GG",
    "GH",
    "GI",
    "GL",
    "GM",
    "GN",
    "GP",
    "GQ",
    "GR",
    "GS",
    "GT",
    "GU",
    "GW",
    "GY",
    "HK",
    "HM",
    "HN",
    "HR",
    "HT",
    "HU",
    "IC",
    "ID",
    "IE",
    "IL",
    "IM",
    "IN",
    "IO",
    "IQ",
    "IR",
    "IS",
    "IT",
    "JE",
    "JM",
    "JO",
    "JP",
    "KE",
    "KG",
    "KH",
    "KI",
    "KM",
    "KN",
    "KP",
    "KR",
    "KW",
    "KY",
    "KZ",
    "LA",
    "LB",
    "LC",
    "LI",
    "LK",
    "LR",
    "LS",
    "LT",
    "LU",
    "LV",
    "LY",
    "MA",
    "MC",
    "MD",
    "ME",
    "MF",
    "MG",
    "MH",
    "MK",
    "ML",
    "MM",
    "MN",
    "MO",
    "MP",
    "MQ",
    "MR",
    "MS",
    "MT",
    "MU",
    "MV",
    "MW",
    "MX",
    "MY",
    "MZ",
    "NA",
    "NC",
    "NE",
    "NF",
    "NG",
    "NI",
    "NL",
    "NO",
    "NP",
    "NR",
    "NU",
    "NZ",
    "OM",
    "PA",
    "PE",
    "PF",
    "PG",
    "PH",
    "PK",
    "PL",
    "PM",
    "PN",
    "PR",
    "PS",
    "PT",
    "PW",
    "PY",
    "QA",
    "QO",
    "RE",
    "RO",
    "RS",
    "RU",
    "RW",
    "SA",
    "SB",
    "SC",
    "SD",
    "SE",
    "SG",
    "SH",
    "SI",
    "SJ",
    "SK",
    "SL",
    "SM",
    "SN",
    "SO",
    "SR",
    "SS",
    "ST",
    "SV",
    "SX",
    "SY",
    "SZ",
    "TA",
    "TC",
    "TD",
    "TF",
    "TG",
    "TH",
    "TJ",
    "TK",
    "TL",
    "TM",
    "TN",
    "TO",
    "TR",
    "TT",
    "TV",
    "TW",
    "TZ",
    "UA",
    "UG",
    "UM",
    "UN",
    "US",
    "UY",
    "UZ",
    "VA",
    "VC",
    "VE",
    "VG",
    "VI",
    "VN",
    "VU",
    "WF",
    "WS",
    "XK",
    "YE",
    "YT",
    "ZA",
    "ZM",
    "ZW"
  ],
  "002": [
    "002",
    "002-status-grouping",
    "011",
    "014",
    "015",
    "017",
    "018",
    "202",
    "AO",
    "BF",
    "BI",
    "BJ",
    "BW",
    "CD",
    "CF",
    "CG",
    "CI",
    "CM",
    "CV",
    "DJ",
    "DZ",
    "EA",
    "EG",
    "EH",
    "ER",
    "ET",
    "GA",
    "GH",
    "GM",
    "GN",
    "GQ",
    "GW",
    "IC",
    "IO",
    "KE",
    "KM",
    "LR",
    "LS",
    "LY",
    "MA",
    "MG",
    "ML",
    "MR",
    "MU",
    "MW",
    "MZ",
    "NA",
    "NE",
    "NG",
    "RE",
    "RW",
    "SC",
    "SD",
    "SH",
    "SL",
    "SN",
    "SO",
    "SS",
    "ST",
    "SZ",
    "TD",
    "TF",
    "TG",
    "TN",
    "TZ",
    "UG",
    "YT",
    "ZA",
    "ZM",
    "ZW"
  ],
  "003": [
    "003",
    "013",
    "021",
    "029",
    "AG",
    "AI",
    "AW",
    "BB",
    "BL",
    "BM",
    "BQ",
    "BS",
    "BZ",
    "CA",
    "CR",
    "CU",
    "CW",
    "DM",
    "DO",
    "GD",
    "GL",
    "GP",
    "GT",
    "HN",
    "HT",
    "JM",
    "KN",
    "KY",
    "LC",
    "MF",
    "MQ",
    "MS",
    "MX",
    "NI",
    "PA",
    "PM",
    "PR",
    "SV",
    "SX",
    "TC",
    "TT",
    "US",
    "VC",
    "VG",
    "VI"
  ],
  "005": [
    "005",
    "AR",
    "BO",
    "BR",
    "BV",
    "CL",
    "CO",
    "EC",
    "FK",
    "GF",
    "GS",
    "GY",
    "PE",
    "PY",
    "SR",
    "UY",
    "VE"
  ],
  "009": [
    "009",
    "053",
    "054",
    "057",
    "061",
    "AC",
    "AQ",
    "AS",
    "AU",
    "CC",
    "CK",
    "CP",
    "CX",
    "DG",
    "FJ",
    "FM",
    "GU",
    "HM",
    "KI",
    "MH",
    "MP",
    "NC",
    "NF",
    "NR",
    "NU",
    "NZ",
    "PF",
    "PG",
    "PN",
    "PW",
    "QO",
    "SB",
    "TA",
    "TK",
    "TO",
    "TV",
    "UM",
    "VU",
    "WF",
    "WS"
  ],
  "011": [
    "011",
    "BF",
    "BJ",
    "CI",
    "CV",
    "GH",
    "GM",
    "GN",
    "GW",
    "LR",
    "ML",
    "MR",
    "NE",
    "NG",
    "SH",
    "SL",
    "SN",
    "TG"
  ],
  "013": [
    "013",
    "BZ",
    "CR",
    "GT",
    "HN",
    "MX",
    "NI",
    "PA",
    "SV"
  ],
  "014": [
    "014",
    "BI",
    "DJ",
    "ER",
    "ET",
    "IO",
    "KE",
    "KM",
    "MG",
    "MU",
    "MW",
    "MZ",
    "RE",
    "RW",
    "SC",
    "SO",
    "SS",
    "TF",
    "TZ",
    "UG",
    "YT",
    "ZM",
    "ZW"
  ],
  "015": [
    "015",
    "DZ",
    "EA",
    "EG",
    "EH",
    "IC",
    "LY",
    "MA",
    "SD",
    "TN"
  ],
  "017": [
    "017",
    "AO",
    "CD",
    "CF",
    "CG",
    "CM",
    "GA",
    "GQ",
    "ST",
    "TD"
  ],
  "018": [
    "018",
    "BW",
    "LS",
    "NA",
    "SZ",
    "ZA"
  ],
  "019": [
    "003",
    "005",
    "013",
    "019",
    "019-status-grouping",
    "021",
    "029",
    "419",
    "AG",
    "AI",
    "AR",
    "AW",
    "BB",
    "BL",
    "BM",
    "BO",
    "BQ",
    "BR",
    "BS",
    "BV",
    "BZ",
    "CA",
    "CL",
    "CO",
    "CR",
    "CU",
    "CW",
    "DM",
    "DO",
    "EC",
    "FK",
    "GD",
    "GF",
    "GL",
    "GP",
    "GS",
    "GT",
    "GY",
    "HN",
    "HT",
    "JM",
    "KN",
    "KY",
    "LC",
    "MF",
    "MQ",
    "MS",
    "MX",
    "NI",
    "PA",
    "PE",
    "PM",
    "PR",
    "PY",
    "SR",
    "SV",
    "SX",
    "TC",
    "TT",
    "US",
    "UY",
    "VC",
    "VE",
    "VG",
    "VI"
  ],
  "021": [
    "021",
    "BM",
    "CA",
    "GL",
    "PM",
    "US"
  ],
  "029": [
    "029",
    "AG",
    "AI",
    "AW",
    "BB",
    "BL",
    "BQ",
    "BS",
    "CU",
    "CW",
    "DM",
    "DO",
    "GD",
    "GP",
    "HT",
    "JM",
    "KN",
    "KY",
    "LC",
    "MF",
    "MQ",
    "MS",
    "PR",
    "SX",
    "TC",
    "TT",
    "VC",
    "VG",
    "VI"
  ],
  "030": [
    "030",
    "CN",
    "HK",
    "JP",
    "KP",
    "KR",
    "MN",
    "MO",
    "TW"
  ],
  "034": [
    "034",
    "AF",
    "BD",
    "BT",
    "IN",
    "IR",
    "LK",
    "MV",
    "NP",
    "PK"
  ],
  "035": [
    "035",
    "BN",
    "ID",
    "KH",
    "LA",
    "MM",
    "MY",
    "PH",
    "SG",
    "TH",
    "TL",
    "VN"
  ],
  "039": [
    "039",
    "AD",
    "AL",
    "BA",
    "ES",
    "GI",
    "GR",
    "HR",
    "IT",
    "ME",
    "MK",
    "MT",
    "PT",
    "RS",
    "SI",
    "SM",
    "VA",
    "XK"
  ],
  "053": [
    "053",
    "AU",
    "CC",
    "CX",
    "HM",
    "NF",
    "NZ"
  ],
  "054": [
    "054",
    "FJ",
    "NC",
    "PG",
    "SB",
    "VU"
  ],
  "057": [
    "057",
    "FM",
    "GU",
    "KI",
    "MH",
    "MP",
    "NR",
    "PW",
    "UM"
  ],
  "061": [
    "061",
    "AS",
    "CK",
    "NU",
    "PF",
    "PN",
    "TK",
    "TO",
    "TV",
    "WF",
    "WS"
  ],
  142: [
    "030",
    "034",
    "035",
    "142",
    "143",
    "145",
    "AE",
    "AF",
    "AM",
    "AZ",
    "BD",
    "BH",
    "BN",
    "BT",
    "CN",
    "CY",
    "GE",
    "HK",
    "ID",
    "IL",
    "IN",
    "IQ",
    "IR",
    "JO",
    "JP",
    "KG",
    "KH",
    "KP",
    "KR",
    "KW",
    "KZ",
    "LA",
    "LB",
    "LK",
    "MM",
    "MN",
    "MO",
    "MV",
    "MY",
    "NP",
    "OM",
    "PH",
    "PK",
    "PS",
    "QA",
    "SA",
    "SG",
    "SY",
    "TH",
    "TJ",
    "TL",
    "TM",
    "TR",
    "TW",
    "UZ",
    "VN",
    "YE"
  ],
  143: [
    "143",
    "KG",
    "KZ",
    "TJ",
    "TM",
    "UZ"
  ],
  145: [
    "145",
    "AE",
    "AM",
    "AZ",
    "BH",
    "CY",
    "GE",
    "IL",
    "IQ",
    "JO",
    "KW",
    "LB",
    "OM",
    "PS",
    "QA",
    "SA",
    "SY",
    "TR",
    "YE"
  ],
  150: [
    "039",
    "150",
    "151",
    "154",
    "155",
    "AD",
    "AL",
    "AT",
    "AX",
    "BA",
    "BE",
    "BG",
    "BY",
    "CH",
    "CQ",
    "CZ",
    "DE",
    "DK",
    "EE",
    "ES",
    "FI",
    "FO",
    "FR",
    "GB",
    "GG",
    "GI",
    "GR",
    "HR",
    "HU",
    "IE",
    "IM",
    "IS",
    "IT",
    "JE",
    "LI",
    "LT",
    "LU",
    "LV",
    "MC",
    "MD",
    "ME",
    "MK",
    "MT",
    "NL",
    "NO",
    "PL",
    "PT",
    "RO",
    "RS",
    "RU",
    "SE",
    "SI",
    "SJ",
    "SK",
    "SM",
    "UA",
    "VA",
    "XK"
  ],
  151: [
    "151",
    "BG",
    "BY",
    "CZ",
    "HU",
    "MD",
    "PL",
    "RO",
    "RU",
    "SK",
    "UA"
  ],
  154: [
    "154",
    "AX",
    "CQ",
    "DK",
    "EE",
    "FI",
    "FO",
    "GB",
    "GG",
    "IE",
    "IM",
    "IS",
    "JE",
    "LT",
    "LV",
    "NO",
    "SE",
    "SJ"
  ],
  155: [
    "155",
    "AT",
    "BE",
    "CH",
    "DE",
    "FR",
    "LI",
    "LU",
    "MC",
    "NL"
  ],
  202: [
    "011",
    "014",
    "017",
    "018",
    "202",
    "AO",
    "BF",
    "BI",
    "BJ",
    "BW",
    "CD",
    "CF",
    "CG",
    "CI",
    "CM",
    "CV",
    "DJ",
    "ER",
    "ET",
    "GA",
    "GH",
    "GM",
    "GN",
    "GQ",
    "GW",
    "IO",
    "KE",
    "KM",
    "LR",
    "LS",
    "MG",
    "ML",
    "MR",
    "MU",
    "MW",
    "MZ",
    "NA",
    "NE",
    "NG",
    "RE",
    "RW",
    "SC",
    "SH",
    "SL",
    "SN",
    "SO",
    "SS",
    "ST",
    "SZ",
    "TD",
    "TF",
    "TG",
    "TZ",
    "UG",
    "YT",
    "ZA",
    "ZM",
    "ZW"
  ],
  419: [
    "005",
    "013",
    "029",
    "419",
    "AG",
    "AI",
    "AR",
    "AW",
    "BB",
    "BL",
    "BO",
    "BQ",
    "BR",
    "BS",
    "BV",
    "BZ",
    "CL",
    "CO",
    "CR",
    "CU",
    "CW",
    "DM",
    "DO",
    "EC",
    "FK",
    "GD",
    "GF",
    "GP",
    "GS",
    "GT",
    "GY",
    "HN",
    "HT",
    "JM",
    "KN",
    "KY",
    "LC",
    "MF",
    "MQ",
    "MS",
    "MX",
    "NI",
    "PA",
    "PE",
    "PR",
    "PY",
    "SR",
    "SV",
    "SX",
    "TC",
    "TT",
    "UY",
    "VC",
    "VE",
    "VG",
    "VI"
  ],
  EU: [
    "AT",
    "BE",
    "BG",
    "CY",
    "CZ",
    "DE",
    "DK",
    "EE",
    "ES",
    "EU",
    "FI",
    "FR",
    "GR",
    "HR",
    "HU",
    "IE",
    "IT",
    "LT",
    "LU",
    "LV",
    "MT",
    "NL",
    "PL",
    "PT",
    "RO",
    "SE",
    "SI",
    "SK"
  ],
  EZ: [
    "AT",
    "BE",
    "CY",
    "DE",
    "EE",
    "ES",
    "EZ",
    "FI",
    "FR",
    "GR",
    "IE",
    "IT",
    "LT",
    "LU",
    "LV",
    "MT",
    "NL",
    "PT",
    "SI",
    "SK"
  ],
  QO: [
    "AC",
    "AQ",
    "CP",
    "DG",
    "QO",
    "TA"
  ],
  UN: [
    "AD",
    "AE",
    "AF",
    "AG",
    "AL",
    "AM",
    "AO",
    "AR",
    "AT",
    "AU",
    "AZ",
    "BA",
    "BB",
    "BD",
    "BE",
    "BF",
    "BG",
    "BH",
    "BI",
    "BJ",
    "BN",
    "BO",
    "BR",
    "BS",
    "BT",
    "BW",
    "BY",
    "BZ",
    "CA",
    "CD",
    "CF",
    "CG",
    "CH",
    "CI",
    "CL",
    "CM",
    "CN",
    "CO",
    "CR",
    "CU",
    "CV",
    "CY",
    "CZ",
    "DE",
    "DJ",
    "DK",
    "DM",
    "DO",
    "DZ",
    "EC",
    "EE",
    "EG",
    "ER",
    "ES",
    "ET",
    "FI",
    "FJ",
    "FM",
    "FR",
    "GA",
    "GB",
    "GD",
    "GE",
    "GH",
    "GM",
    "GN",
    "GQ",
    "GR",
    "GT",
    "GW",
    "GY",
    "HN",
    "HR",
    "HT",
    "HU",
    "ID",
    "IE",
    "IL",
    "IN",
    "IQ",
    "IR",
    "IS",
    "IT",
    "JM",
    "JO",
    "JP",
    "KE",
    "KG",
    "KH",
    "KI",
    "KM",
    "KN",
    "KP",
    "KR",
    "KW",
    "KZ",
    "LA",
    "LB",
    "LC",
    "LI",
    "LK",
    "LR",
    "LS",
    "LT",
    "LU",
    "LV",
    "LY",
    "MA",
    "MC",
    "MD",
    "ME",
    "MG",
    "MH",
    "MK",
    "ML",
    "MM",
    "MN",
    "MR",
    "MT",
    "MU",
    "MV",
    "MW",
    "MX",
    "MY",
    "MZ",
    "NA",
    "NE",
    "NG",
    "NI",
    "NL",
    "NO",
    "NP",
    "NR",
    "NZ",
    "OM",
    "PA",
    "PE",
    "PG",
    "PH",
    "PK",
    "PL",
    "PT",
    "PW",
    "PY",
    "QA",
    "RO",
    "RS",
    "RU",
    "RW",
    "SA",
    "SB",
    "SC",
    "SD",
    "SE",
    "SG",
    "SI",
    "SK",
    "SL",
    "SM",
    "SN",
    "SO",
    "SR",
    "SS",
    "ST",
    "SV",
    "SY",
    "SZ",
    "TD",
    "TG",
    "TH",
    "TJ",
    "TL",
    "TM",
    "TN",
    "TO",
    "TR",
    "TT",
    "TV",
    "TZ",
    "UA",
    "UG",
    "UN",
    "US",
    "UY",
    "UZ",
    "VC",
    "VE",
    "VN",
    "VU",
    "WS",
    "YE",
    "ZA",
    "ZM",
    "ZW"
  ]
}, gn = /-u(?:-[0-9a-z]{2,8})+/gi;
function O(e, r, t) {
  if (t === void 0 && (t = Error), !e)
    throw new t(r);
}
var ei = 838, ve;
function ri() {
  var e, r;
  if (!ve) {
    var t = (r = (e = ye.supplemental.languageMatching["written-new"][0]) === null || e === void 0 ? void 0 : e.paradigmLocales) === null || r === void 0 ? void 0 : r._locales.split(" "), n = ye.supplemental.languageMatching["written-new"].slice(1, 5), a = ye.supplemental.languageMatching["written-new"].slice(5), i = a.map(function(s) {
      var o = Object.keys(s)[0], u = s[o];
      return {
        supported: o,
        desired: u._desired,
        distance: +u._distance,
        oneway: u.oneway === "true"
      };
    }, {});
    ve = {
      matches: i,
      matchVariables: n.reduce(function(s, o) {
        var u = Object.keys(o)[0], d = o[u];
        return s[u.slice(1)] = d._value.split("+"), s;
      }, {}),
      paradigmLocales: x(x([], t, !0), t.map(function(s) {
        return new Intl.Locale(s.replace(/_/g, "-")).maximize().toString();
      }), !0)
    };
  }
  return ve;
}
function te(e, r, t) {
  var n = r.split("-"), a = n[0], i = n[1], s = n[2], o = !0;
  if (s && s[0] === "$") {
    var u = s[1] !== "!", d = u ? t[s.slice(1)] : t[s.slice(2)], c = d.map(function(l) {
      return Qa[l] || [l];
    }).reduce(function(l, h) {
      return x(x([], l, !0), h, !0);
    }, []);
    o && (o = c.indexOf(e.region || "") > 1 == u);
  } else
    o && (o = e.region ? s === "*" || s === e.region : !0);
  return o && (o = e.script ? i === "*" || i === e.script : !0), o && (o = e.language ? a === "*" || a === e.language : !0), o;
}
function Wr(e) {
  return [e.language, e.script, e.region].filter(Boolean).join("-");
}
function ge(e, r, t) {
  for (var n = 0, a = t.matches; n < a.length; n++) {
    var i = a[n], s = te(e, i.desired, t.matchVariables) && te(r, i.supported, t.matchVariables);
    if (!i.oneway && !s && (s = te(e, i.supported, t.matchVariables) && te(r, i.desired, t.matchVariables)), s) {
      var o = i.distance * 10;
      return t.paradigmLocales.indexOf(Wr(e)) > -1 != t.paradigmLocales.indexOf(Wr(r)) > -1 ? o - 1 : o;
    }
  }
  throw new Error("No matching distance found");
}
function ti(e, r) {
  var t = new Intl.Locale(e).maximize(), n = new Intl.Locale(r).maximize(), a = {
    language: t.language,
    script: t.script || "",
    region: t.region || ""
  }, i = {
    language: n.language,
    script: n.script || "",
    region: n.region || ""
  }, s = 0, o = ri();
  return a.language !== i.language && (s += ge({
    language: t.language,
    script: "",
    region: ""
  }, {
    language: n.language,
    script: "",
    region: ""
  }, o)), a.script !== i.script && (s += ge({
    language: t.language,
    script: a.script,
    region: ""
  }, {
    language: n.language,
    script: a.script,
    region: ""
  }, o)), a.region !== i.region && (s += ge(a, i, o)), s;
}
function ni(e, r, t) {
  t === void 0 && (t = ei);
  var n = 1 / 0, a = {
    matchedDesiredLocale: "",
    distances: {}
  };
  return e.forEach(function(i, s) {
    a.distances[i] || (a.distances[i] = {}), r.forEach(function(o) {
      var u = ti(i, o) + 0 + s * 40;
      a.distances[i][o] = u, u < n && (n = u, a.matchedDesiredLocale = i, a.matchedSupportedLocale = o);
    });
  }), n >= t && (a.matchedDesiredLocale = void 0, a.matchedSupportedLocale = void 0), a;
}
function ai(e, r, t) {
  var n, a, i = [], s = r.reduce(function(u, d) {
    var c = d.replace(gn, "");
    return i.push(c), u[c] = d, u;
  }, {}), o = ni(i, e);
  return o.matchedSupportedLocale && o.matchedDesiredLocale && (n = o.matchedSupportedLocale, a = s[o.matchedDesiredLocale].slice(o.matchedDesiredLocale.length) || void 0), n ? {
    locale: n,
    extension: a
  } : { locale: t() };
}
function ii(e, r) {
  var t = r.toLowerCase();
  O(e !== void 0, "ukey must be defined");
  var n = t;
  return n;
}
function Xr(e) {
  return Intl.getCanonicalLocales(e)[0];
}
function si(e, r, t) {
  O(e.indexOf("-u-") === -1, "Expected locale to not have a Unicode locale extension");
  for (var n = "-u", a = 0, i = r; a < i.length; a++) {
    var s = i[a];
    n += "-".concat(s);
  }
  for (var o = 0, u = t; o < u.length; o++) {
    var d = u[o], c = d.key, l = d.value;
    n += "-".concat(c), l !== "" && (n += "-".concat(l));
  }
  if (n === "-u")
    return Xr(e);
  var h = e.indexOf("-x-"), y;
  if (h === -1)
    y = e + n;
  else {
    var m = e.slice(0, h), _ = e.slice(h);
    y = m + n + _;
  }
  return Xr(y);
}
function oi(e, r) {
  for (var t = r; ; ) {
    if (e.indexOf(t) > -1)
      return t;
    var n = t.lastIndexOf("-");
    if (!~n)
      return;
    n >= 2 && t[n - 2] === "-" && (n -= 2), t = t.slice(0, n);
  }
}
function ui(e, r, t) {
  for (var n = { locale: "" }, a = 0, i = r; a < i.length; a++) {
    var s = i[a], o = s.replace(gn, ""), u = oi(e, o);
    if (u)
      return n.locale = u, s !== o && (n.extension = s.slice(o.length, s.length)), n;
  }
  return n.locale = t(), n;
}
function di(e) {
  O(e === e.toLowerCase(), "Expected extension to be lowercase"), O(e.slice(0, 3) === "-u-", "Expected extension to be a Unicode locale extension");
  for (var r = [], t = [], n, a = e.length, i = 3; i < a; ) {
    var s = e.indexOf("-", i), o = void 0;
    s === -1 ? o = a - i : o = s - i;
    var u = e.slice(i, i + o);
    O(o >= 2, "Expected a subtag to have at least 2 characters"), n === void 0 && o != 2 ? r.indexOf(u) === -1 && r.push(u) : o === 2 ? (n = { key: u, value: "" }, t.find(function(d) {
      return d.key === (n == null ? void 0 : n.key);
    }) === void 0 && t.push(n)) : (n == null ? void 0 : n.value) === "" ? n.value = u : (O(n !== void 0, "Expected keyword to be defined"), n.value += "-" + u), i += o + 1;
  }
  return { attributes: r, keywords: t };
}
function ci(e, r, t, n, a, i) {
  var s, o = t.localeMatcher, u;
  o === "lookup" ? u = ui(Array.from(e), r, i) : u = ai(Array.from(e), r, i), u == null && (u = {
    locale: i(),
    extension: ""
  });
  var d = u.locale, c = a[d], l = { locale: "en", dataLocale: d }, h, y;
  u.extension ? (h = di(u.extension), y = h.keywords) : y = [];
  for (var m = [], _ = function(S) {
    var H = (s = c == null ? void 0 : c[S]) !== null && s !== void 0 ? s : [];
    O(Array.isArray(H), "keyLocaleData for ".concat(S, " must be an array"));
    var I = H[0];
    O(I === void 0 || typeof I == "string", "value must be a string or undefined");
    var G = void 0, Hr = y.find(function(Cn) {
      return Cn.key === S;
    });
    if (Hr) {
      var de = Hr.value;
      de !== "" ? H.indexOf(de) > -1 && (I = de, G = {
        key: S,
        value: I
      }) : H.indexOf("true") > -1 && (I = "true", G = {
        key: S,
        value: I
      });
    }
    var B = t[S];
    if (O(B == null || typeof B == "string", "optionsValue must be a string or undefined"), typeof B == "string") {
      var Mn = S.toLowerCase();
      B = ii(Mn, B), B === "" && (B = "true");
    }
    B !== I && H.indexOf(B) > -1 && (I = B, G = void 0), G && m.push(G), l[S] = I;
  }, v = 0, g = n; v < g.length; v++) {
    var E = g[v];
    _(E);
  }
  var T = [];
  return m.length > 0 && (T = [], d = si(d, T, m)), l.locale = d, l;
}
function hi(e, r, t, n) {
  return ci(r, $a(e), {
    localeMatcher: (n == null ? void 0 : n.algorithm) || "best fit"
  }, [], {}, function() {
    return t;
  }).locale;
}
var ne = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function pn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var pe, Jr;
function li() {
  if (Jr) return pe;
  Jr = 1, pe = t, t.flatten = t, t.unflatten = n;
  function e(a) {
    return a && a.constructor && typeof a.constructor.isBuffer == "function" && a.constructor.isBuffer(a);
  }
  function r(a) {
    return a;
  }
  function t(a, i) {
    i = i || {};
    const s = i.delimiter || ".", o = i.maxDepth, u = i.transformKey || r, d = {};
    function c(l, h, y) {
      y = y || 1, Object.keys(l).forEach(function(m) {
        const _ = l[m], v = i.safe && Array.isArray(_), g = Object.prototype.toString.call(_), E = e(_), T = g === "[object Object]" || g === "[object Array]", S = h ? h + s + u(m) : u(m);
        if (!v && !E && T && Object.keys(_).length && (!i.maxDepth || y < o))
          return c(_, S, y + 1);
        d[S] = _;
      });
    }
    return c(a), d;
  }
  function n(a, i) {
    i = i || {};
    const s = i.delimiter || ".", o = i.overwrite || !1, u = i.transformKey || r, d = {};
    if (e(a) || Object.prototype.toString.call(a) !== "[object Object]")
      return a;
    function l(m) {
      const _ = Number(m);
      return isNaN(_) || m.indexOf(".") !== -1 || i.object ? m : _;
    }
    function h(m, _, v) {
      return Object.keys(v).reduce(function(g, E) {
        return g[m + s + E] = v[E], g;
      }, _);
    }
    function y(m) {
      const _ = Object.prototype.toString.call(m), v = _ === "[object Array]", g = _ === "[object Object]";
      if (m) {
        if (v)
          return !m.length;
        if (g)
          return !Object.keys(m).length;
      } else return !0;
    }
    return a = Object.keys(a).reduce(function(m, _) {
      const v = Object.prototype.toString.call(a[_]);
      return !(v === "[object Object]" || v === "[object Array]") || y(a[_]) ? (m[_] = a[_], m) : h(
        _,
        m,
        t(a[_], i)
      );
    }, {}), Object.keys(a).forEach(function(m) {
      const _ = m.split(s).map(u);
      let v = l(_.shift()), g = l(_[0]), E = d;
      for (; g !== void 0; ) {
        if (v === "__proto__")
          return;
        const T = Object.prototype.toString.call(E[v]), S = T === "[object Object]" || T === "[object Array]";
        if (!o && !S && typeof E[v] != "undefined")
          return;
        (o && !S || !o && E[v] == null) && (E[v] = typeof g == "number" && !i.object ? [] : {}), E = E[v], _.length > 0 && (v = l(_.shift()), g = l(_[0]));
      }
      E[v] = n(a[m], i);
    }), d;
  }
  return pe;
}
var _i = li();
const Yr = /* @__PURE__ */ pn(_i);
var be, $r;
function Cr() {
  if ($r) return be;
  $r = 1;
  var e = Array.isArray;
  return be = e, be;
}
var Ee, Qr;
function fi() {
  if (Qr) return Ee;
  Qr = 1;
  var e = typeof ne == "object" && ne && ne.Object === Object && ne;
  return Ee = e, Ee;
}
var we, et;
function Ar() {
  if (et) return we;
  et = 1;
  var e = fi(), r = typeof self == "object" && self && self.Object === Object && self, t = e || r || Function("return this")();
  return we = t, we;
}
var Te, rt;
function Ir() {
  if (rt) return Te;
  rt = 1;
  var e = Ar(), r = e.Symbol;
  return Te = r, Te;
}
var Se, tt;
function mi() {
  if (tt) return Se;
  tt = 1;
  var e = Ir(), r = Object.prototype, t = r.hasOwnProperty, n = r.toString, a = e ? e.toStringTag : void 0;
  function i(s) {
    var o = t.call(s, a), u = s[a];
    try {
      s[a] = void 0;
      var d = !0;
    } catch (l) {
    }
    var c = n.call(s);
    return d && (o ? s[a] = u : delete s[a]), c;
  }
  return Se = i, Se;
}
var xe, nt;
function yi() {
  if (nt) return xe;
  nt = 1;
  var e = Object.prototype, r = e.toString;
  function t(n) {
    return r.call(n);
  }
  return xe = t, xe;
}
var Me, at;
function bn() {
  if (at) return Me;
  at = 1;
  var e = Ir(), r = mi(), t = yi(), n = "[object Null]", a = "[object Undefined]", i = e ? e.toStringTag : void 0;
  function s(o) {
    return o == null ? o === void 0 ? a : n : i && i in Object(o) ? r(o) : t(o);
  }
  return Me = s, Me;
}
var Ce, it;
function vi() {
  if (it) return Ce;
  it = 1;
  function e(r) {
    return r != null && typeof r == "object";
  }
  return Ce = e, Ce;
}
var Ae, st;
function Lr() {
  if (st) return Ae;
  st = 1;
  var e = bn(), r = vi(), t = "[object Symbol]";
  function n(a) {
    return typeof a == "symbol" || r(a) && e(a) == t;
  }
  return Ae = n, Ae;
}
var Ie, ot;
function gi() {
  if (ot) return Ie;
  ot = 1;
  var e = Cr(), r = Lr(), t = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, n = /^\w*$/;
  function a(i, s) {
    if (e(i))
      return !1;
    var o = typeof i;
    return o == "number" || o == "symbol" || o == "boolean" || i == null || r(i) ? !0 : n.test(i) || !t.test(i) || s != null && i in Object(s);
  }
  return Ie = a, Ie;
}
var Le, ut;
function En() {
  if (ut) return Le;
  ut = 1;
  function e(r) {
    var t = typeof r;
    return r != null && (t == "object" || t == "function");
  }
  return Le = e, Le;
}
var He, dt;
function pi() {
  if (dt) return He;
  dt = 1;
  var e = bn(), r = En(), t = "[object AsyncFunction]", n = "[object Function]", a = "[object GeneratorFunction]", i = "[object Proxy]";
  function s(o) {
    if (!r(o))
      return !1;
    var u = e(o);
    return u == n || u == a || u == t || u == i;
  }
  return He = s, He;
}
var Ne, ct;
function bi() {
  if (ct) return Ne;
  ct = 1;
  var e = Ar(), r = e["__core-js_shared__"];
  return Ne = r, Ne;
}
var Re, ht;
function Ei() {
  if (ht) return Re;
  ht = 1;
  var e = bi(), r = function() {
    var n = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return n ? "Symbol(src)_1." + n : "";
  }();
  function t(n) {
    return !!r && r in n;
  }
  return Re = t, Re;
}
var Be, lt;
function wi() {
  if (lt) return Be;
  lt = 1;
  var e = Function.prototype, r = e.toString;
  function t(n) {
    if (n != null) {
      try {
        return r.call(n);
      } catch (a) {
      }
      try {
        return n + "";
      } catch (a) {
      }
    }
    return "";
  }
  return Be = t, Be;
}
var Pe, _t;
function Ti() {
  if (_t) return Pe;
  _t = 1;
  var e = pi(), r = Ei(), t = En(), n = wi(), a = /[\\^$.*+?()[\]{}|]/g, i = /^\[object .+?Constructor\]$/, s = Function.prototype, o = Object.prototype, u = s.toString, d = o.hasOwnProperty, c = RegExp(
    "^" + u.call(d).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function l(h) {
    if (!t(h) || r(h))
      return !1;
    var y = e(h) ? c : i;
    return y.test(n(h));
  }
  return Pe = l, Pe;
}
var Oe, ft;
function Si() {
  if (ft) return Oe;
  ft = 1;
  function e(r, t) {
    return r == null ? void 0 : r[t];
  }
  return Oe = e, Oe;
}
var Ge, mt;
function wn() {
  if (mt) return Ge;
  mt = 1;
  var e = Ti(), r = Si();
  function t(n, a) {
    var i = r(n, a);
    return e(i) ? i : void 0;
  }
  return Ge = t, Ge;
}
var De, yt;
function se() {
  if (yt) return De;
  yt = 1;
  var e = wn(), r = e(Object, "create");
  return De = r, De;
}
var Fe, vt;
function xi() {
  if (vt) return Fe;
  vt = 1;
  var e = se();
  function r() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Fe = r, Fe;
}
var Ue, gt;
function Mi() {
  if (gt) return Ue;
  gt = 1;
  function e(r) {
    var t = this.has(r) && delete this.__data__[r];
    return this.size -= t ? 1 : 0, t;
  }
  return Ue = e, Ue;
}
var qe, pt;
function Ci() {
  if (pt) return qe;
  pt = 1;
  var e = se(), r = "__lodash_hash_undefined__", t = Object.prototype, n = t.hasOwnProperty;
  function a(i) {
    var s = this.__data__;
    if (e) {
      var o = s[i];
      return o === r ? void 0 : o;
    }
    return n.call(s, i) ? s[i] : void 0;
  }
  return qe = a, qe;
}
var je, bt;
function Ai() {
  if (bt) return je;
  bt = 1;
  var e = se(), r = Object.prototype, t = r.hasOwnProperty;
  function n(a) {
    var i = this.__data__;
    return e ? i[a] !== void 0 : t.call(i, a);
  }
  return je = n, je;
}
var Ve, Et;
function Ii() {
  if (Et) return Ve;
  Et = 1;
  var e = se(), r = "__lodash_hash_undefined__";
  function t(n, a) {
    var i = this.__data__;
    return this.size += this.has(n) ? 0 : 1, i[n] = e && a === void 0 ? r : a, this;
  }
  return Ve = t, Ve;
}
var ke, wt;
function Li() {
  if (wt) return ke;
  wt = 1;
  var e = xi(), r = Mi(), t = Ci(), n = Ai(), a = Ii();
  function i(s) {
    var o = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++o < u; ) {
      var d = s[o];
      this.set(d[0], d[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = r, i.prototype.get = t, i.prototype.has = n, i.prototype.set = a, ke = i, ke;
}
var Ke, Tt;
function Hi() {
  if (Tt) return Ke;
  Tt = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Ke = e, Ke;
}
var ze, St;
function Ni() {
  if (St) return ze;
  St = 1;
  function e(r, t) {
    return r === t || r !== r && t !== t;
  }
  return ze = e, ze;
}
var Ze, xt;
function oe() {
  if (xt) return Ze;
  xt = 1;
  var e = Ni();
  function r(t, n) {
    for (var a = t.length; a--; )
      if (e(t[a][0], n))
        return a;
    return -1;
  }
  return Ze = r, Ze;
}
var We, Mt;
function Ri() {
  if (Mt) return We;
  Mt = 1;
  var e = oe(), r = Array.prototype, t = r.splice;
  function n(a) {
    var i = this.__data__, s = e(i, a);
    if (s < 0)
      return !1;
    var o = i.length - 1;
    return s == o ? i.pop() : t.call(i, s, 1), --this.size, !0;
  }
  return We = n, We;
}
var Xe, Ct;
function Bi() {
  if (Ct) return Xe;
  Ct = 1;
  var e = oe();
  function r(t) {
    var n = this.__data__, a = e(n, t);
    return a < 0 ? void 0 : n[a][1];
  }
  return Xe = r, Xe;
}
var Je, At;
function Pi() {
  if (At) return Je;
  At = 1;
  var e = oe();
  function r(t) {
    return e(this.__data__, t) > -1;
  }
  return Je = r, Je;
}
var Ye, It;
function Oi() {
  if (It) return Ye;
  It = 1;
  var e = oe();
  function r(t, n) {
    var a = this.__data__, i = e(a, t);
    return i < 0 ? (++this.size, a.push([t, n])) : a[i][1] = n, this;
  }
  return Ye = r, Ye;
}
var $e, Lt;
function Gi() {
  if (Lt) return $e;
  Lt = 1;
  var e = Hi(), r = Ri(), t = Bi(), n = Pi(), a = Oi();
  function i(s) {
    var o = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++o < u; ) {
      var d = s[o];
      this.set(d[0], d[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = r, i.prototype.get = t, i.prototype.has = n, i.prototype.set = a, $e = i, $e;
}
var Qe, Ht;
function Di() {
  if (Ht) return Qe;
  Ht = 1;
  var e = wn(), r = Ar(), t = e(r, "Map");
  return Qe = t, Qe;
}
var er, Nt;
function Fi() {
  if (Nt) return er;
  Nt = 1;
  var e = Li(), r = Gi(), t = Di();
  function n() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (t || r)(),
      string: new e()
    };
  }
  return er = n, er;
}
var rr, Rt;
function Ui() {
  if (Rt) return rr;
  Rt = 1;
  function e(r) {
    var t = typeof r;
    return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? r !== "__proto__" : r === null;
  }
  return rr = e, rr;
}
var tr, Bt;
function ue() {
  if (Bt) return tr;
  Bt = 1;
  var e = Ui();
  function r(t, n) {
    var a = t.__data__;
    return e(n) ? a[typeof n == "string" ? "string" : "hash"] : a.map;
  }
  return tr = r, tr;
}
var nr, Pt;
function qi() {
  if (Pt) return nr;
  Pt = 1;
  var e = ue();
  function r(t) {
    var n = e(this, t).delete(t);
    return this.size -= n ? 1 : 0, n;
  }
  return nr = r, nr;
}
var ar, Ot;
function ji() {
  if (Ot) return ar;
  Ot = 1;
  var e = ue();
  function r(t) {
    return e(this, t).get(t);
  }
  return ar = r, ar;
}
var ir, Gt;
function Vi() {
  if (Gt) return ir;
  Gt = 1;
  var e = ue();
  function r(t) {
    return e(this, t).has(t);
  }
  return ir = r, ir;
}
var sr, Dt;
function ki() {
  if (Dt) return sr;
  Dt = 1;
  var e = ue();
  function r(t, n) {
    var a = e(this, t), i = a.size;
    return a.set(t, n), this.size += a.size == i ? 0 : 1, this;
  }
  return sr = r, sr;
}
var or, Ft;
function Ki() {
  if (Ft) return or;
  Ft = 1;
  var e = Fi(), r = qi(), t = ji(), n = Vi(), a = ki();
  function i(s) {
    var o = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++o < u; ) {
      var d = s[o];
      this.set(d[0], d[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = r, i.prototype.get = t, i.prototype.has = n, i.prototype.set = a, or = i, or;
}
var ur, Ut;
function zi() {
  if (Ut) return ur;
  Ut = 1;
  var e = Ki(), r = "Expected a function";
  function t(n, a) {
    if (typeof n != "function" || a != null && typeof a != "function")
      throw new TypeError(r);
    var i = function() {
      var s = arguments, o = a ? a.apply(this, s) : s[0], u = i.cache;
      if (u.has(o))
        return u.get(o);
      var d = n.apply(this, s);
      return i.cache = u.set(o, d) || u, d;
    };
    return i.cache = new (t.Cache || e)(), i;
  }
  return t.Cache = e, ur = t, ur;
}
var dr, qt;
function Zi() {
  if (qt) return dr;
  qt = 1;
  var e = zi(), r = 500;
  function t(n) {
    var a = e(n, function(s) {
      return i.size === r && i.clear(), s;
    }), i = a.cache;
    return a;
  }
  return dr = t, dr;
}
var cr, jt;
function Wi() {
  if (jt) return cr;
  jt = 1;
  var e = Zi(), r = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, t = /\\(\\)?/g, n = e(function(a) {
    var i = [];
    return a.charCodeAt(0) === 46 && i.push(""), a.replace(r, function(s, o, u, d) {
      i.push(u ? d.replace(t, "$1") : o || s);
    }), i;
  });
  return cr = n, cr;
}
var hr, Vt;
function Xi() {
  if (Vt) return hr;
  Vt = 1;
  function e(r, t) {
    for (var n = -1, a = r == null ? 0 : r.length, i = Array(a); ++n < a; )
      i[n] = t(r[n], n, r);
    return i;
  }
  return hr = e, hr;
}
var lr, kt;
function Ji() {
  if (kt) return lr;
  kt = 1;
  var e = Ir(), r = Xi(), t = Cr(), n = Lr(), a = e ? e.prototype : void 0, i = a ? a.toString : void 0;
  function s(o) {
    if (typeof o == "string")
      return o;
    if (t(o))
      return r(o, s) + "";
    if (n(o))
      return i ? i.call(o) : "";
    var u = o + "";
    return u == "0" && 1 / o == -1 / 0 ? "-0" : u;
  }
  return lr = s, lr;
}
var _r, Kt;
function Yi() {
  if (Kt) return _r;
  Kt = 1;
  var e = Ji();
  function r(t) {
    return t == null ? "" : e(t);
  }
  return _r = r, _r;
}
var fr, zt;
function $i() {
  if (zt) return fr;
  zt = 1;
  var e = Cr(), r = gi(), t = Wi(), n = Yi();
  function a(i, s) {
    return e(i) ? i : r(i, s) ? [i] : t(n(i));
  }
  return fr = a, fr;
}
var mr, Zt;
function Qi() {
  if (Zt) return mr;
  Zt = 1;
  var e = Lr();
  function r(t) {
    if (typeof t == "string" || e(t))
      return t;
    var n = t + "";
    return n == "0" && 1 / t == -1 / 0 ? "-0" : n;
  }
  return mr = r, mr;
}
var yr, Wt;
function es() {
  if (Wt) return yr;
  Wt = 1;
  var e = $i(), r = Qi();
  function t(n, a) {
    a = e(a, n);
    for (var i = 0, s = a.length; n != null && i < s; )
      n = n[r(a[i++])];
    return i && i == s ? n : void 0;
  }
  return yr = t, yr;
}
var vr, Xt;
function rs() {
  if (Xt) return vr;
  Xt = 1;
  var e = es();
  function r(t, n, a) {
    var i = t == null ? void 0 : e(t, n);
    return i === void 0 ? a : i;
  }
  return vr = r, vr;
}
var ts = rs();
const ns = /* @__PURE__ */ pn(ts), as = {
  a: "ȧ",
  A: "Ȧ",
  b: "ƀ",
  B: "Ɓ",
  c: "ƈ",
  C: "Ƈ",
  d: "ḓ",
  D: "Ḓ",
  e: "ḗ",
  E: "Ḗ",
  f: "ƒ",
  F: "Ƒ",
  g: "ɠ",
  G: "Ɠ",
  h: "ħ",
  H: "Ħ",
  i: "ī",
  I: "Ī",
  j: "ĵ",
  J: "Ĵ",
  k: "ķ",
  K: "Ķ",
  l: "ŀ",
  L: "Ŀ",
  m: "ḿ",
  M: "Ḿ",
  n: "ƞ",
  N: "Ƞ",
  o: "ǿ",
  O: "Ǿ",
  p: "ƥ",
  P: "Ƥ",
  q: "ɋ",
  Q: "Ɋ",
  r: "ř",
  R: "Ř",
  s: "ş",
  S: "Ş",
  t: "ŧ",
  T: "Ŧ",
  v: "ṽ",
  V: "Ṽ",
  u: "ŭ",
  U: "Ŭ",
  w: "ẇ",
  W: "Ẇ",
  x: "ẋ",
  X: "Ẋ",
  y: "ẏ",
  Y: "Ẏ",
  z: "ẑ",
  Z: "Ẑ"
}, is = fn(), ss = (e) => {
  process.env.NODE_ENV !== "production" && console.error(e);
};
var k, Z, F, W, J, Y, U, Tn, Sn, xn;
class os {
  constructor({ locales: r, defaultLocale: t, userPreferredLocales: n, pseudoMode: a = !1, pseudoPercentage: i = 1.3 }) {
    D(this, U);
    D(this, k);
    D(this, Z);
    D(this, F);
    D(this, W);
    D(this, J);
    D(this, Y);
    if (r.some((s) => !("code" in s) || !("messages" in s)))
      throw new Error("Each locale object should provide values for 'code' and 'messages'");
    if (!r.some((s) => s.code === t))
      throw new Error(`Default locale ${t} does not match any provided locale`);
    j(this, k, r), j(this, Z, Q(this, U, Tn).call(this, L(this, k))), j(this, F, t), j(this, W, n || []), j(this, J, a), j(this, Y, i);
  }
  createIntlWithLocale(r, t = ss) {
    let n = Q(this, U, Sn).call(this, r, t);
    const a = L(this, Z)[n], i = L(this, Z)[L(this, F)];
    return Q(this, U, xn).call(this, {
      locale: n,
      messages: a,
      defaultLocale: L(this, F),
      defaultMessages: i,
      errorHandler: t
    });
  }
  getAvailableLocales() {
    return L(this, k).map((r) => r.code);
  }
}
k = new WeakMap(), Z = new WeakMap(), F = new WeakMap(), W = new WeakMap(), J = new WeakMap(), Y = new WeakMap(), U = new WeakSet(), Tn = function(r) {
  return r.reduce((t, { code: n, messages: a }) => he(ce({}, t), {
    [n]: a
  }), {});
}, Sn = function(r, t) {
  const n = r ? [r, ...L(this, W)] : L(this, W);
  let a;
  try {
    a = hi(
      n,
      L(this, k).map((i) => i.code),
      L(this, F),
      { algorithm: "lookup" }
    );
  } catch (i) {
    a = L(this, F), t(i);
  }
  return a;
}, xn = function({ locale: r, messages: t, defaultLocale: n, defaultMessages: a, errorHandler: i }) {
  const s = Yr(t), o = Yr(a), u = Ya(
    {
      locale: r,
      messages: s,
      defaultLocale: n,
      onError: i
    },
    is
  ), d = (c, l) => {
    const h = ns(o, c, ""), y = u.formatMessage({ id: c, defaultMessage: h }, l, {
      ignoreTag: !0
    });
    if (y && L(this, J)) {
      const m = Math.floor(y.length * L(this, Y));
      return y.split("").reduce((_, v, g) => {
        const E = as[v] || v;
        return _.length + (y.length - g) < m ? `${_}${E}${E}` : _.length === m ? _ : `${_}${E}`;
      }, "");
    }
    return y;
  };
  return u.$t = d, u.$d = u.formatDate, u;
};
const ds = {
  install: (e, { defaultLocale: r, locales: t, pseudoMode: n, pseudoPercentage: a }) => {
    const i = navigator.languages || [], s = new os({
      locales: t,
      defaultLocale: r,
      userPreferredLocales: i,
      pseudoMode: n,
      pseudoPercentage: a
    });
    e.config.globalProperties.$intlManager = s;
    const o = (u, d) => {
      const c = s.createIntlWithLocale(u, d);
      e.config.globalProperties.$intl = he(ce({}, c), { $setLocale: o }), e.config.globalProperties.$t = c.$t, e.config.globalProperties.$d = c.$d;
    };
    o(null);
  }
};
export {
  os as IntlManager,
  ds as VueIntl
};
